(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[11],{

/***/ "qEec":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddToCart$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Cart$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CartButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return index$4; });
/* unused harmony export EmptyCart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return index$5; });
/* unused harmony export LineItems */
/* unused harmony export MiniCart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MiniCartModal; });
/* unused harmony export Models */
/* unused harmony export Operations */
/* unused harmony export TYPE_DETAILS_EYE_SIDE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Upsell; });
/* unused harmony export cartCountVar */
/* unused harmony export cartPriceMapper */
/* unused harmony export createProductObject */
/* unused harmony export getActiveVoucherCodes */
/* unused harmony export getAddedLineItems */
/* unused harmony export getAttribute */
/* unused harmony export getCalculatedMaximumQuantity */
/* unused harmony export getContactLensSpecs */
/* unused harmony export getDiscountDescriptions */
/* unused harmony export getLineItemAvailability */
/* unused harmony export getLineItemDiscount */
/* unused harmony export getLineItemImageUrl */
/* unused harmony export getLineItemName */
/* unused harmony export getLineItemPrice */
/* unused harmony export getLocalizedAttribute */
/* unused harmony export getProductUrl */
/* unused harmony export getValidationErrorCodes */
/* unused harmony export lineItemDataMapper */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _grandvision_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("k3MI");
/* harmony import */ var _grandvision_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ytpp");
/* harmony import */ var _grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("7nHn");
/* harmony import */ var _grandvision_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("B4sh");
/* harmony import */ var _grandvision_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PM6f");
/* harmony import */ var _grandvision_elements__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("m5xE");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("TSYQ");
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("Ur++");
/* harmony import */ var _grandvision_icons__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("MZek");
/* harmony import */ var _grandvision_forms__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("wE1k");
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("PGlZ");
/* harmony import */ var _grandvision_api_client__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("Dott");














var CartContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])(null);
CartContext.displayName = 'CartContext';
var useCart = function () {
    var context = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(CartContext);
    if (!context) {
        throw new Error('No Cart available. You might still need to wrap the application with the CartProvider component.');
    }
    return context;
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var discount = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment DiscountFragment on Discount {\n    id\n    isActive\n    key\n    name {\n      locale\n      value\n      __typename\n    }\n    description {\n      locale\n      value\n    }\n    type\n    value {\n      centAmount\n      percentage\n      scale\n      type\n      __typename\n    }\n    validFrom\n    validUntil\n    __typename\n  }\n"], ["\n  fragment DiscountFragment on Discount {\n    id\n    isActive\n    key\n    name {\n      locale\n      value\n      __typename\n    }\n    description {\n      locale\n      value\n    }\n    type\n    value {\n      centAmount\n      percentage\n      scale\n      type\n      __typename\n    }\n    validFrom\n    validUntil\n    __typename\n  }\n"])));
var templateObject_1;

var eyePrescription = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  fragment EyePrescriptionFragment on SingleEyePrescription {\n    baseCurve\n    diameter\n    power\n    axis\n    cylinder\n    addition\n    pupillaryDistance\n  }\n"], ["\n  fragment EyePrescriptionFragment on SingleEyePrescription {\n    baseCurve\n    diameter\n    power\n    axis\n    cylinder\n    addition\n    pupillaryDistance\n  }\n"])));
var templateObject_1$1;

var legacyProduct = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  fragment LegacyProductFragment on LegacyProduct {\n    id\n    sku\n    productType\n    masterData {\n      current {\n        variant {\n          availability {\n            channels {\n              key\n              value {\n                isOnStock\n                availableQuantity\n              }\n            }\n          }\n          attributes {\n            name\n            value\n          }\n          images {\n            url\n          }\n          sku\n        }\n        name {\n          value\n          locale\n        }\n        slug {\n          value\n          locale\n        }\n      }\n    }\n  }\n"], ["\n  fragment LegacyProductFragment on LegacyProduct {\n    id\n    sku\n    productType\n    masterData {\n      current {\n        variant {\n          availability {\n            channels {\n              key\n              value {\n                isOnStock\n                availableQuantity\n              }\n            }\n          }\n          attributes {\n            name\n            value\n          }\n          images {\n            url\n          }\n          sku\n        }\n        name {\n          value\n          locale\n        }\n        slug {\n          value\n          locale\n        }\n      }\n    }\n  }\n"])));
var templateObject_1$2;

var lineItemPrice = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  fragment LineItemPriceFragment on LineItemPrice {\n    total {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    unit {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n  __typename\n  }\n"], ["\n  fragment LineItemPriceFragment on LineItemPrice {\n    total {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n    unit {\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      gross\n      net\n      subtotal\n      tax {\n        amount\n        portions {\n          amount\n          rate\n          __typename\n        }\n        __typename\n      }\n      __typename\n    }\n  __typename\n  }\n"])));
var templateObject_1$3;

var lineItemBundle = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  fragment LineItemBundleFragment on LineItemBundle {\n    id\n    sku\n    bundleLineItems {\n      isMainBundleLineItem\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      legacyProduct {\n        ...LegacyProductFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment LineItemBundleFragment on LineItemBundle {\n    id\n    sku\n    bundleLineItems {\n      isMainBundleLineItem\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      legacyProduct {\n        ...LegacyProductFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), legacyProduct, lineItemPrice, discount);
var templateObject_1$4;

var cartDetails = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  fragment CartDetailsFragment on Cart {\n    __typename\n    id\n    appliedDiscounts {\n      name {\n        locale\n        value\n        __typename\n      }\n      requiresDiscountCode\n      __typename\n    }\n    numberOfItems\n    price {\n      subtotal\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      net\n      gross\n      tax {\n        amount\n        portions {\n          rate\n          amount\n          __typename\n        }\n        __typename\n      }\n      shippingPrice\n      paymentMethodPrice\n      __typename\n    }\n    vouchers {\n      code\n      isActive\n      name\n      state\n      __typename\n    }\n    lineItems {\n      id\n      lineItemType\n      typeDetails {\n        __typename\n        ... on ContactLensesTypeDetails {\n          eyeSide\n          __typename\n        }\n        ... on ContactLensBundleBeneluxTypeDetails {\n          prescription {\n            rightLens {\n              baseCurve\n              diameter\n              power\n              axis\n              cylinder\n            }\n            leftLens {\n              baseCurve\n              diameter\n              power\n              axis\n              cylinder\n            }\n          }\n        }\n        ... on BundlePrescriptionGlassesTypeDetails {\n          newPrescription {\n            leftLens {\n              ...EyePrescriptionFragment\n            }\n            rightLens {\n              ...EyePrescriptionFragment\n            }\n            opticianDetails {\n              type\n              opticianName\n              postalCode\n              city\n              country\n              address\n              streetName\n              additionalStreetInfo\n              additionalAddressInfo\n              region\n            }\n            examDate\n            expiryDate\n          }\n          prescriptionFile {\n            __typename\n          }\n          isEmailPrescription\n          isExistingCustomer\n        }\n      }\n      isGift\n      sku\n      quantity\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      __typename\n      ... on LineItemRegular {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemContactLenses {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemBundle {\n        lineItemType\n        bundleLineItemsType\n        bundleLineItems {\n          type\n          isMainBundleLineItem\n          legacyProduct {\n            ...LegacyProductFragment\n            __typename\n          }\n        }\n      }\n      ... on LineItemBundle {\n        ...LineItemBundleFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  fragment CartDetailsFragment on Cart {\n    __typename\n    id\n    appliedDiscounts {\n      name {\n        locale\n        value\n        __typename\n      }\n      requiresDiscountCode\n      __typename\n    }\n    numberOfItems\n    price {\n      subtotal\n      discount {\n        amount\n        percentage\n        __typename\n      }\n      net\n      gross\n      tax {\n        amount\n        portions {\n          rate\n          amount\n          __typename\n        }\n        __typename\n      }\n      shippingPrice\n      paymentMethodPrice\n      __typename\n    }\n    vouchers {\n      code\n      isActive\n      name\n      state\n      __typename\n    }\n    lineItems {\n      id\n      lineItemType\n      typeDetails {\n        __typename\n        ... on ContactLensesTypeDetails {\n          eyeSide\n          __typename\n        }\n        ... on ContactLensBundleBeneluxTypeDetails {\n          prescription {\n            rightLens {\n              baseCurve\n              diameter\n              power\n              axis\n              cylinder\n            }\n            leftLens {\n              baseCurve\n              diameter\n              power\n              axis\n              cylinder\n            }\n          }\n        }\n        ... on BundlePrescriptionGlassesTypeDetails {\n          newPrescription {\n            leftLens {\n              ...EyePrescriptionFragment\n            }\n            rightLens {\n              ...EyePrescriptionFragment\n            }\n            opticianDetails {\n              type\n              opticianName\n              postalCode\n              city\n              country\n              address\n              streetName\n              additionalStreetInfo\n              additionalAddressInfo\n              region\n            }\n            examDate\n            expiryDate\n          }\n          prescriptionFile {\n            __typename\n          }\n          isEmailPrescription\n          isExistingCustomer\n        }\n      }\n      isGift\n      sku\n      quantity\n      discounts {\n        ...DiscountFragment\n      }\n      price {\n        ...LineItemPriceFragment\n      }\n      __typename\n      ... on LineItemRegular {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemContactLenses {\n        legacyProduct {\n          ...LegacyProductFragment\n          __typename\n        }\n        __typename\n      }\n      ... on LineItemBundle {\n        lineItemType\n        bundleLineItemsType\n        bundleLineItems {\n          type\n          isMainBundleLineItem\n          legacyProduct {\n            ...LegacyProductFragment\n            __typename\n          }\n        }\n      }\n      ... on LineItemBundle {\n        ...LineItemBundleFragment\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), legacyProduct, lineItemBundle, lineItemPrice, discount, eyePrescription);
var templateObject_1$5;

var cartValidationErrors = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  fragment CartValidationErrorsFragment on CartValidationErrors {\n    cartErrors {\n      defaultMessage\n      validationCode\n      passed\n    }\n    cartLineItemErrors {\n      errors {\n        defaultMessage\n        validationCode\n        passed\n      }\n      itemId\n    }\n  }\n"], ["\n  fragment CartValidationErrorsFragment on CartValidationErrors {\n    cartErrors {\n      defaultMessage\n      validationCode\n      passed\n    }\n    cartLineItemErrors {\n      errors {\n        defaultMessage\n        validationCode\n        passed\n      }\n      itemId\n    }\n  }\n"])));
var templateObject_1$6;



var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  cartDetails: cartDetails,
  cartValidationErrors: cartValidationErrors
});

var ADD_CART_LINE_ITEMS = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  mutation AddCartLineItems($cartInput: AddCartLineItemsInput!) {\n    addCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation AddCartLineItems($cartInput: AddCartLineItemsInput!) {\n    addCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$7;

var ADD_CART_VOUCHER_CODES = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  mutation AddCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    addCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation AddCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    addCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$8;

var CREATE_CART = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  mutation CreateCart($cartInput: CreateCartInput!) {\n    createCart(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation CreateCart($cartInput: CreateCartInput!) {\n    createCart(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$9;

var REMOVE_CART_VOUCHER_CODES = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n  mutation RemoveCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    removeCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation RemoveCartVoucherCodes($cartInput: CartVoucherCodesInput!) {\n    removeCartVoucherCodes(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$a;

var REMOVE_CART_LINE_ITEMS = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n  mutation RemoveCartLineItems($cartInput: RemoveCartLineItemsInput!) {\n    removeCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation RemoveCartLineItems($cartInput: RemoveCartLineItemsInput!) {\n    removeCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$b;

var UPDATE_CART_LINE_ITEMS = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  mutation UpdateCartLineItems($cartInput: UpdateCartLineItemsInput!) {\n    updateCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation UpdateCartLineItems($cartInput: UpdateCartLineItemsInput!) {\n    updateCartLineItems(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$c;

var REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  mutation ReplaceContactLensBundleBeneluxCartLineItem(\n    $cartInput: ReplaceCartContactLensBundleBeneluxLineItemInput!\n  ) {\n    replaceContactLensBundleBeneluxCartLineItem(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"], ["\n  mutation ReplaceContactLensBundleBeneluxCartLineItem(\n    $cartInput: ReplaceCartContactLensBundleBeneluxLineItemInput!\n  ) {\n    replaceContactLensBundleBeneluxCartLineItem(cartInput: $cartInput) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n      success\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$d;



var index$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ADD_CART_LINE_ITEMS: ADD_CART_LINE_ITEMS,
  ADD_CART_VOUCHER_CODES: ADD_CART_VOUCHER_CODES,
  CREATE_CART: CREATE_CART,
  REMOVE_CART_VOUCHER_CODES: REMOVE_CART_VOUCHER_CODES,
  REMOVE_CART_LINE_ITEMS: REMOVE_CART_LINE_ITEMS,
  UPDATE_CART_LINE_ITEMS: UPDATE_CART_LINE_ITEMS,
  REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM: REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM
});

var GET_CART = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  query GetCart($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"], ["\n  query GetCart($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        ...CartDetailsFragment\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n  ", "\n"])), cartDetails, cartValidationErrors);
var templateObject_1$e;

var GET_TOTAL_LINE_ITEMS = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* gql */ "b"])(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  query GetTotalLineItems($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        id\n        numberOfItems\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n"], ["\n  query GetTotalLineItems($id: ID!) {\n    getCart(id: $id) {\n      cart {\n        id\n        numberOfItems\n      }\n      validationErrors {\n        ...CartValidationErrorsFragment\n      }\n    }\n  }\n  ", "\n"])), cartValidationErrors);
var templateObject_1$f;



var index$2 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  GET_CART: GET_CART,
  GET_TOTAL_LINE_ITEMS: GET_TOTAL_LINE_ITEMS
});



var index$3 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  Fragments: index,
  Mutations: index$1,
  Queries: index$2
});

var cartCountVar = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* makeVar */ "d"])(0);

var cartPriceMapper = function (prices) {
    return {
        discountPrice: prices.discount.amount,
        subTotalPrice: prices.subtotal,
        shippingPrice: prices.shippingPrice,
        totalPrice: prices.gross,
    };
};

var convertAttributeToLowerCase = function (attribute) {
    if (!attribute) {
        return '';
    }
    return Array.isArray(attribute) ? attribute.join().toLowerCase() : attribute.toLowerCase();
};
var calcPrice = function (centAmount) {
    var price = !isNaN(centAmount) ? (centAmount / 100).toFixed(2).toString() : '0.00';
    if (price === '0') {
        return '0.00';
    }
    return price;
};
var createPriceSpecification = function (lineItem) {
    var unit = lineItem.price.unit;
    return {
        '@type': 'CompoundPriceSpecification',
        name: 'Price',
        price: String(calcPrice(unit.gross)),
        priceCurrency: lineItem.currency,
        validFrom: lineItem.discount.validFrom,
        validThrough: lineItem.discount.validUntil,
        valueAddedTaxIncluded: true,
        priceComponent: [
            {
                '@type': 'UnitPriceSpecification',
                name: 'Price excluding VAT',
                price: String(calcPrice(unit.net)),
                valueAddedTaxIncluded: false,
            },
            {
                '@type': 'UnitPriceSpecification',
                name: 'VAT',
                price: String(calcPrice(unit.taxAmount)),
                valueAddedTaxIncluded: true,
            },
        ],
    };
};
var createOfferObject = function (lineItem) {
    return {
        '@type': 'Offer',
        includesObject: {
            '@type': 'TypeAndQuantityNode',
            amountOfThisGood: 1,
        },
        priceSpecification: createPriceSpecification(lineItem),
    };
};
var createProductObject = function (lineItem) {
    var url = (window.location && window.location.origin) || '';
    if (lineItem.productUrl) {
        url += lineItem.productUrl;
    }
    if (lineItem.type === 'prescription-glasses') {
        var frame_1 = lineItem.frame, name_1 = lineItem.name;
        var brand_1 = frame_1.brand, productId_1 = frame_1.productId, sku_1 = frame_1.sku;
        return {
            '@type': 'Product',
            '@id': url + "#product",
            category: 'Optical',
            url: url,
            brand: brand_1.name,
            name: name_1,
            sku: sku_1,
            gtin13: sku_1,
            productID: productId_1,
            offers: [createOfferObject(lineItem)],
        };
    }
    var name = lineItem.name, sku = lineItem.sku, productId = lineItem.productId, type = lineItem.type, brand = lineItem.brand;
    var frame = lineItem.type === 'sunglasses' ? lineItem.frame : null;
    return {
        '@type': 'Product',
        '@id': url + "#product",
        url: url,
        model: (frame === null || frame === void 0 ? void 0 : frame.frameShape) || '',
        name: name || '',
        productID: productId || '',
        gtin13: sku || '',
        category: type || '',
        brand: brand.name,
        material: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameMaterial),
        color: convertAttributeToLowerCase(frame === null || frame === void 0 ? void 0 : frame.frameColor),
        offers: [createOfferObject(lineItem)],
    };
};

var getActiveVoucherCodes = function (vouchers) {
    if (!vouchers) {
        return;
    }
    return vouchers.filter(function (voucher) { return voucher.isActive; }).map(function (voucher) { return voucher.code; });
};

/**
 * Only returns true when both set a and b match exactly
 */
var isExactMatch = function (a, b) {
    var e_1, _a;
    var diff = new Set(a);
    try {
        for (var b_1 = __values(b), b_1_1 = b_1.next(); !b_1_1.done; b_1_1 = b_1.next()) {
            var elem = b_1_1.value;
            if (diff.has(elem)) {
                diff.delete(elem);
            }
            else {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (b_1_1 && !b_1_1.done && (_a = b_1.return)) _a.call(b_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return diff.size <= 0;
};
var isMissing = function (value) {
    return typeof value === 'undefined' ||
        value === null ||
        (typeof value === 'object' && Object.getOwnPropertyNames(value).length < 1);
};
/**
 * Server and client have a different way of expressing a missing value. With
 * this util we can easily catch this situation.
 */
function areBothMissing(server, client) {
    return isMissing(server) && isMissing(client);
}

var areSameOpticianDetails = function (server, draft) {
    var e_1, _a;
    var sameExpiryDate = areBothMissing(server.expiryDate, draft.expiryDate) || server.expiryDate === draft.expiryDate;
    var sameExamDate = areBothMissing(server.examDate, draft.examDate) || server.examDate === draft.examDate;
    var sameDates = sameExpiryDate && sameExamDate;
    if (!sameDates) {
        return false;
    }
    if (areBothMissing(draft.opticianDetails, server.opticianDetails)) {
        // If they're both missing we consider them equal
        return true;
    }
    else if (!draft.opticianDetails || !server.opticianDetails) {
        // If one of them is missing we consider them to not be equal
        return false;
    }
    try {
        for (var _b = __values(Object.getOwnPropertyNames(draft.opticianDetails)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var field = _c.value;
            var serverValue = server.opticianDetails[field];
            var draftValue = draft.opticianDetails[field];
            /**
             * If server and client both express in their own way that
             * the value is missing, we consider them to be equal.
             */
            if (areBothMissing(serverValue, draftValue)) {
                continue;
            }
            if (serverValue !== draftValue) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
};

var opticalParametersOnServer = [
    'baseCurve',
    'diameter',
    'power',
    'axis',
    'cylinder',
    'addition',
    'pupillaryDistance',
];
var areSamePrescriptionParameters = function (server, draft) {
    var e_1, _a;
    var serverMap = new Map(Object.entries(server).filter(function (_a) {
        var _b = __read(_a, 1), k = _b[0];
        return k !== '__typename';
    }));
    try {
        for (var opticalParametersOnServer_1 = __values(opticalParametersOnServer), opticalParametersOnServer_1_1 = opticalParametersOnServer_1.next(); !opticalParametersOnServer_1_1.done; opticalParametersOnServer_1_1 = opticalParametersOnServer_1.next()) {
            var attributeName = opticalParametersOnServer_1_1.value;
            var serverValue = serverMap.get(attributeName);
            var draftValue = draft[attributeName];
            /**
             * If server and client both express in their own way that
             * the value is missing, we consider them to be equal.
             */
            if (areBothMissing(serverValue, draftValue)) {
                serverMap.delete(attributeName);
                continue;
            }
            if (serverValue !== draftValue) {
                return false;
            }
            serverMap.delete(attributeName);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (opticalParametersOnServer_1_1 && !opticalParametersOnServer_1_1.done && (_a = opticalParametersOnServer_1.return)) _a.call(opticalParametersOnServer_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return serverMap.size <= 0;
};

var isSamePrescription = function (server, draft) {
    if (server.isEmailPrescription) {
        return draft.type === 'email-prescription';
    }
    else if (server.isExistingCustomer) {
        return draft.type === 'existing-customer';
    }
    else if (server.prescriptionFile) {
        // TODO: RX-PRESCRIPTION-UPLOAD
        // Returning false here as we're never adding this type from the FE so it should never match
        // When we do add the file-upload we should re-consider this
        return false;
    }
    if (draft.type !== 'new-prescription' || !server.newPrescription) {
        return false;
    }
    var _a = server.newPrescription, leftLens = _a.leftLens, rightLens = _a.rightLens, examDate = _a.examDate, expiryDate = _a.expiryDate, opticianDetails = _a.opticianDetails;
    return (areSamePrescriptionParameters(leftLens, draft.details.leftLens) &&
        areSamePrescriptionParameters(rightLens, draft.details.rightLens) &&
        areSameOpticianDetails({ examDate: examDate, expiryDate: expiryDate, opticianDetails: opticianDetails }, draft.details));
};

var areSamePrescriptionGlassesLineItem = function (serverLineItem, draftLineItem) {
    var _a;
    if (((_a = serverLineItem.typeDetails) === null || _a === void 0 ? void 0 : _a.__typename) !== 'BundlePrescriptionGlassesTypeDetails') {
        return false;
    }
    var serverSkus = new Set(serverLineItem.bundleLineItems.map(function (bl) { return bl.legacyProduct.sku; }));
    var draftSkus = new Set(__spread([draftLineItem.sku], draftLineItem.bundleLineItems.map(function (b) { return b.sku; })));
    return (isExactMatch(serverSkus, draftSkus) &&
        isSamePrescription(serverLineItem.typeDetails, draftLineItem.prescription));
};

var sameProduct = function (serverLineItem, draft) {
    // A LineItemBundle is considered the same product only when all SKUs match exactly
    if (serverLineItem.__typename === 'LineItemBundle' && draft.type === 'prescription-glasses') {
        return areSamePrescriptionGlassesLineItem(serverLineItem, draft);
    }
    return serverLineItem.sku === draft.sku;
};
var getAddedLineItems = function (lineItemsInCart, newLineItems) {
    var lookup = newLineItems.reduce(function (m, lineItemDraft) {
        var _a;
        return __assign(__assign({}, m), (_a = {}, _a[lineItemDraft.sku] = lineItemDraft, _a));
    }, {});
    // First we get the relevant line items in full from the cart response, matched by SKU from the payload
    var addedLineItemsFromCartResponse = lineItemsInCart.filter(function (lineItem) { return lineItem.sku in lookup && sameProduct(lineItem, lookup[lineItem.sku]); });
    // We need quantity and total pricing based on the products that were just added, excluding eventual previously existing
    // products
    return addedLineItemsFromCartResponse.map(function (lineItem) {
        var _a;
        var draft = lookup[lineItem.sku];
        var quantity = (_a = draft === null || draft === void 0 ? void 0 : draft.quantity) !== null && _a !== void 0 ? _a : 1;
        if (lineItem.quantity === quantity) {
            return lineItem;
        }
        return __assign(__assign({}, lineItem), { quantity: quantity, price: getTotalPricePerAddedQuantity(lineItem.price, quantity) });
    });
};
// Overwrite total pricing based on unit price * quantity
var getTotalPricePerAddedQuantity = function (price, quantity) { return (__assign(__assign({}, price), { total: __assign(__assign({}, price.total), { gross: price.unit.gross * quantity, net: price.unit.net * quantity, subtotal: price.unit.subtotal * quantity, discount: __assign(__assign({}, price.total.discount), { amount: price.unit.discount.amount * quantity }), tax: __assign(__assign({}, price.total.tax), { amount: price.unit.tax.amount * quantity, portions: price.unit.tax.portions.map(function (portion, index) { return (__assign(__assign({}, portion), { amount: price.unit.tax.portions[index].amount * quantity })); }) }) }) })); };

var getAttribute = function (variant, attrName) {
    var attrValue = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getAttrValue */ "m"])(variant, attrName);
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isNumber */ "z"])(attrValue) || Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isString */ "B"])(attrValue)) {
        return String(attrValue);
    }
    return '';
};

var numOrDefault = function (v, d) { return (typeof v === 'number' && !isNaN(v) ? v : d); };
var getCalculatedMaximumQuantity = function (maximumQuantity, availableQuantity) {
    var max = numOrDefault(maximumQuantity, Infinity);
    return Math.min(max, numOrDefault(availableQuantity, max));
};

var contactLensOpticalParameters = new Set([
    'baseCurve',
    'diameter',
    'axis',
    'power',
    'cylinder',
    'addition',
]);
var getContactLensSpecs = function (attributes) {
    return attributes.filter(function (attribute) { return contactLensOpticalParameters.has(attribute.name); });
};
var TYPE_DETAILS_EYE_SIDE = { left: 'LEFT', right: 'RIGHT', both: 'BOTH' };

var getLocalizedString = function (locale, localizedStrings) {
    var _a, _b;
    if (!localizedStrings) {
        return '';
    }
    var value = (_a = localizedStrings.find(function (string) { return string.locale === locale; })) === null || _a === void 0 ? void 0 : _a.value;
    // Business rule, localized version unavailable, try 'en' fallback
    if (value === undefined) {
        value = (_b = localizedStrings.find(function (string) { return string.locale.substr(0, 2) === 'en'; })) === null || _b === void 0 ? void 0 : _b.value;
    }
    return value || '';
};

var getDiscountDescriptions = function (appliedDiscounts, locale) {
    // Business rule: filter out discount that require a discount code
    var filteredDiscounts = appliedDiscounts.filter(function (discount) { return !discount.requiresDiscountCode; });
    return filteredDiscounts.map(function (discount) { return getLocalizedString(locale, discount.name); });
};

var getLineItemAvailability = function (availability) {
    if (!(availability === null || availability === void 0 ? void 0 : availability.channels)) {
        return undefined;
    }
    var channels = availability.channels.reduce(function (accumulator, currentValue) {
        var _a;
        return __assign(__assign({}, accumulator), (_a = {}, _a[currentValue.key] = {
            isOnStock: currentValue.value.isOnStock,
            availableQuantity: currentValue.value.availableQuantity,
        }, _a));
    }, {});
    return { channels: channels };
};

var getLineItemDiscount = function (discounts, price, locale) {
    var _a, _b;
    var productDiscount = discounts === null || discounts === void 0 ? void 0 : discounts.find(function (discount) { return discount.type === 'ProductDiscount'; });
    return {
        validFrom: (_a = productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.validFrom) !== null && _a !== void 0 ? _a : undefined,
        validUntil: (_b = productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.validUntil) !== null && _b !== void 0 ? _b : undefined,
        absoluteValue: (price === null || price === void 0 ? void 0 : price.total.discount.amount) || 0,
        relativeValue: price ? Number((price.total.discount.percentage * 100).toFixed(2)) : 0,
        description: getLocalizedString(locale, productDiscount === null || productDiscount === void 0 ? void 0 : productDiscount.description),
    };
};

var getLineItemImageUrl = function (variant, staticsUrl) {
    var _a, _b, _c;
    if ((_b = (_a = variant === null || variant === void 0 ? void 0 : variant.images) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.url) {
        return "" + staticsUrl + ((_c = variant === null || variant === void 0 ? void 0 : variant.images) === null || _c === void 0 ? void 0 : _c[0].url) + "?w=275&bg=FFFFFF&fm=jpeg&auto=format";
    }
    return "" + staticsUrl;
};

var getLineItemName = function (product, intl) {
    if (product.productType === 'sunglasses') {
        return String(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getAttrValue */ "m"])(product.masterData.current.variant, 'brand'));
    }
    return getLocalizedString(intl.locale, product.masterData.current.name);
};

var getLineItemPrice = function (priceObj) {
    var total = priceObj.total;
    var unit = priceObj.unit;
    return {
        total: {
            discount: total.discount.amount,
            original: total.subtotal,
            gross: total.gross,
            net: total.net,
            taxAmount: total.tax.amount,
        },
        unit: {
            discount: unit.discount.amount,
            original: unit.subtotal,
            gross: unit.gross,
            net: unit.net,
            taxAmount: unit.tax.amount,
        },
    };
};

var getLocalizedAttribute = function (variant, attrName, locale) {
    var attrValue = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getAttrValue */ "m"])(variant, attrName);
    if (!Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isPlainObject */ "A"])(attrValue)) {
        return undefined;
    }
    return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getLocalizedValue */ "q"])(attrValue, locale);
};

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * Enum for bundle line items product types.
 */
var BundleLineItemProductType;
(function (BundleLineItemProductType) {
    BundleLineItemProductType["LENS"] = "LENS";
    BundleLineItemProductType["SOLUTION"] = "SOLUTION";
})(BundleLineItemProductType || (BundleLineItemProductType = {}));
/**
 * List of possible bundle line item types.
 */
var BundleLineItemType;
(function (BundleLineItemType) {
    BundleLineItemType["COMPOSITE"] = "COMPOSITE";
    BundleLineItemType["CONTACT_LENSES_BENELUX"] = "CONTACT_LENSES_BENELUX";
    BundleLineItemType["PRESCRIPTION_GLASSES"] = "PRESCRIPTION_GLASSES";
})(BundleLineItemType || (BundleLineItemType = {}));
/**
 * List of possible discount types.
 */
var DiscountType;
(function (DiscountType) {
    DiscountType["CartDiscount"] = "CartDiscount";
    DiscountType["ProductDiscount"] = "ProductDiscount";
})(DiscountType || (DiscountType = {}));
/**
 * Absolute or Relative
 */
var DiscountValueType;
(function (DiscountValueType) {
    DiscountValueType["ABSOLUTE"] = "ABSOLUTE";
    DiscountValueType["GIFT"] = "GIFT";
    DiscountValueType["RELATIVE"] = "RELATIVE";
})(DiscountValueType || (DiscountValueType = {}));
/**
 * List of possible eyeSide properties
 */
var EyeSide;
(function (EyeSide) {
    EyeSide["BOTH"] = "BOTH";
    EyeSide["LEFT"] = "LEFT";
    EyeSide["RIGHT"] = "RIGHT";
})(EyeSide || (EyeSide = {}));
/**
 * List of possible line item types.
 */
var LineItemType;
(function (LineItemType) {
    LineItemType["BUNDLE"] = "BUNDLE";
    LineItemType["CONTACTLENSES"] = "CONTACTLENSES";
    LineItemType["REGULAR"] = "REGULAR";
})(LineItemType || (LineItemType = {}));
/**
 * List of possible validation codes for a validation error.
 */
var ValidationCode;
(function (ValidationCode) {
    ValidationCode["CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES"] = "CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES";
    ValidationCode["HAS_VALID_OPTICIAN_DETAILS"] = "HAS_VALID_OPTICIAN_DETAILS";
    ValidationCode["HAS_VALID_PRESCRIPTION_DATA_RANGES"] = "HAS_VALID_PRESCRIPTION_DATA_RANGES";
    ValidationCode["IS_IN_STOCK"] = "IS_IN_STOCK";
    ValidationCode["IS_VALID_AMOUNT_OF_MASTER_VARIANTS"] = "IS_VALID_AMOUNT_OF_MASTER_VARIANTS";
    ValidationCode["IS_VALID_CART_BY_PRESCRIPTION"] = "IS_VALID_CART_BY_PRESCRIPTION";
    ValidationCode["IS_VALID_EXPIRY_DATE"] = "IS_VALID_EXPIRY_DATE";
    ValidationCode["IS_VALID_QUANTITY"] = "IS_VALID_QUANTITY";
    ValidationCode["MAX_QUANTITY_PER_PRODUCT_TYPE"] = "MAX_QUANTITY_PER_PRODUCT_TYPE";
    ValidationCode["MAX_VARIANTS_PER_PRODUCT_TYPE"] = "MAX_VARIANTS_PER_PRODUCT_TYPE";
    ValidationCode["PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT"] = "PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT";
    ValidationCode["PRODUCTS_ARE_PUBLISHED"] = "PRODUCTS_ARE_PUBLISHED";
    ValidationCode["REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE"] = "REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE";
    ValidationCode["VALID_CART_BY_PRODUCT_TYPES"] = "VALID_CART_BY_PRODUCT_TYPES";
    ValidationCode["VALID_RELATIONS_BUNDLE_PRODUCTS"] = "VALID_RELATIONS_BUNDLE_PRODUCTS";
})(ValidationCode || (ValidationCode = {}));
/**
 * List of possible voucher types.
 */
var VoucherState;
(function (VoucherState) {
    VoucherState["ApplicationStoppedByPreviousDiscount"] = "ApplicationStoppedByPreviousDiscount";
    VoucherState["DoesNotMatchCart"] = "DoesNotMatchCart";
    VoucherState["MatchesCart"] = "MatchesCart";
    VoucherState["MaxApplicationReached"] = "MaxApplicationReached";
    VoucherState["NotActive"] = "NotActive";
    VoucherState["NotValid"] = "NotValid";
})(VoucherState || (VoucherState = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================

var upperFirst = function (value) {
    return value[0].toUpperCase() + value.slice(1);
};
var getProductUrl = function (formatProductUrl, lineItemRaw, slug, locale) {
    var _a, _b, _c;
    if (!slug) {
        return undefined;
    }
    if (lineItemRaw.__typename === 'LineItemBundle') {
        var bundleTypeMap = (_a = {},
            _a[BundleLineItemType.CONTACT_LENSES_BENELUX] = 'Contact-lenses',
            _a[BundleLineItemType.PRESCRIPTION_GLASSES] = 'Frames',
            _a[BundleLineItemType.COMPOSITE] = 'TO_BE_IMPLEMENTED',
            _a);
        return formatProductUrl({
            productType: bundleTypeMap[lineItemRaw.bundleLineItemsType],
            sku: lineItemRaw.sku,
            slug: (_b = {}, _b[locale] = slug, _b),
        });
    }
    return formatProductUrl({
        productType: upperFirst(lineItemRaw.legacyProduct.productType),
        sku: lineItemRaw.sku,
        slug: (_c = {}, _c[locale] = slug, _c),
    });
};

var validationErrorLabelMap = {
    CONTAINS_MUTUALLY_EXCLUSIVE_PRODUCT_TYPES: 'validations.containsMutuallyExclusiveProductTypes',
    IS_VALID_AMOUNT_OF_MASTER_VARIANTS: 'validations.maxMasterVariantQuantityExceeded',
    IS_VALID_CART_BY_PRESCRIPTION: 'validations.quantityExceededPrescriptionExpiryDate',
    IS_VALID_EXPIRY_DATE: 'validations.quantityExceededPrescriptionExpiryDate',
    IS_VALID_QUANTITY: 'validations.maxQuantitySkuExceeded',
    IS_IN_STOCK: 'validations.unavailableProductsInCart',
    MAX_VARIANTS_PER_PRODUCT_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    MAX_QUANTITY_PER_PRODUCT_TYPE: 'validations.maxVariantsPerProductTypeQuantityExceeded',
    PRODUCTS_ARE_PUBLISHED: 'validations.unavailableProductsInCart',
    PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT: 'validations.unavailableProductsInCart',
    HAS_VALID_OPTICIAN_DETAILS: 'validations.prescriptionGlassesInvalidBundleCombination',
    HAS_VALID_PRESCRIPTION_DATA_RANGES: 'validations.prescriptionGlassesInvalidBundleCombination',
    REQUIRED_PRODUCT_TYPES_ARE_IN_BUNDLE: 'validations.prescriptionGlassesInvalidBundleCombination',
    VALID_CART_BY_PRODUCT_TYPES: 'validations.prescriptionGlassesInvalidBundleCombination',
    VALID_RELATIONS_BUNDLE_PRODUCTS: 'validations.prescriptionGlassesInvalidBundleCombination',
};
var getValidationErrorCodes = function (validationInput) {
    if (!validationInput) {
        return [];
    }
    var lineItemValidationErrors = validationInput.cartLineItemErrors;
    if (lineItemValidationErrors) {
        return getLineItemValidationErrorCodes(lineItemValidationErrors);
    }
    return [];
};
var getLineItemValidationErrorCodes = function (lineItemValidationErrors) {
    var codes = lineItemValidationErrors.reduce(function (accumulator, currentValue) {
        var validationCode = currentValue.errors.map(function (error) { return error.validationCode; });
        return __spread(accumulator, validationCode);
    }, []);
    var uniqueValidationCodes = __spread(new Set(codes));
    return uniqueValidationCodes.map(function (code) { return validationErrorLabelMap[code]; });
};

var getAllowBackOrder = function (variant) {
    var allowBackOrder = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getAttrValue */ "m"])(variant, 'allowBackOrder');
    return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isBoolean */ "w"])(allowBackOrder) ? allowBackOrder : undefined;
};

var filterEmptySpecs = function (specs) {
    var _a, _b, _c, _d, _e;
    return [
        { name: 'baseCurve', value: (_a = specs.baseCurve) === null || _a === void 0 ? void 0 : _a.toString() },
        { name: 'diameter', value: (_b = specs.diameter) === null || _b === void 0 ? void 0 : _b.toString() },
        { name: 'axis', value: (_c = specs.axis) === null || _c === void 0 ? void 0 : _c.toString() },
        { name: 'power', value: (_d = specs.power) === null || _d === void 0 ? void 0 : _d.toString() },
        { name: 'cylinder', value: (_e = specs.cylinder) === null || _e === void 0 ? void 0 : _e.toString() },
    ].filter(function (spec) { return Boolean(spec.value); });
};
var findProduct = function (lineItems, type) {
    var _a, _b;
    if (!type) {
        return (_a = lineItems.find(function (lineItem) { return lineItem.isMainBundleLineItem; })) === null || _a === void 0 ? void 0 : _a.legacyProduct;
    }
    return (_b = lineItems.find(function (lineItem) { return lineItem.type === type; })) === null || _b === void 0 ? void 0 : _b.legacyProduct;
};
var getSolutionProperties = function (solutionProduct, intl, settings, bundleImages) {
    var _a;
    return {
        solutionSku: solutionProduct.sku,
        solutionName: getLineItemName(solutionProduct, intl),
        solutionImageUrl: (_a = bundleImages === null || bundleImages === void 0 ? void 0 : bundleImages.solution) !== null && _a !== void 0 ? _a : getLineItemImageUrl(solutionProduct.masterData.current.variant, settings.staticsUrl),
    };
};
var mapContactLensesBundleBeneluxLineItem = function (lineItemRaw, settings, intl) {
    var contactLensesProduct = findProduct(lineItemRaw.bundleLineItems, BundleLineItemProductType.LENS);
    var solutionsProduct = findProduct(lineItemRaw.bundleLineItems, BundleLineItemProductType.SOLUTION);
    var mainBundleProduct = findProduct(lineItemRaw.bundleLineItems);
    if (!contactLensesProduct || !mainBundleProduct) {
        console.error('This bundle does not contain Contact Lenses or a mainBundleProduct');
        return null;
    }
    var contactLensVariant = contactLensesProduct.masterData.current.variant;
    var mainProductVariant = mainBundleProduct.masterData.current.variant;
    var slug = getAttribute(mainProductVariant, 'parentSlug');
    var typeDetails = lineItemRaw.typeDetails;
    var _a = typeDetails.prescription, leftLens = _a.leftLens, rightLens = _a.rightLens;
    var bundleImages = settings.getBundleImages ? settings.getBundleImages(lineItemRaw) : undefined;
    var solutionProperties = solutionsProduct
        ? getSolutionProperties(solutionsProduct, intl, settings, bundleImages)
        : null;
    return __assign({ type: 'contact-lenses-subscription', sku: lineItemRaw.sku, imageSku: getAttribute(mainProductVariant, 'imageSku'), productSlug: slug, productId: contactLensesProduct.id, productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale), brand: {
            name: getAttribute(contactLensVariant, 'brand'),
            model: getAttribute(contactLensVariant, 'brandModel'),
            modelCode: getAttribute(contactLensVariant, 'brandModelCode'),
        }, allowBackOrder: getAllowBackOrder(contactLensVariant), availability: getLineItemAvailability(contactLensVariant.availability), currency: intl.currency, discount: getLineItemDiscount(lineItemRaw.discounts, lineItemRaw.price, intl.locale), id: lineItemRaw.id, imageUrl: (bundleImages === null || bundleImages === void 0 ? void 0 : bundleImages.item) || getLineItemImageUrl(contactLensVariant, settings.staticsUrl), isGift: lineItemRaw.isGift, name: getLocalizedAttribute(mainProductVariant, 'header', intl.locale) || '', price: getLineItemPrice(lineItemRaw.price), quantity: lineItemRaw.quantity, lensType: getLocalizedAttribute(mainProductVariant, 'lensType', intl.locale) || '', leftEyeProduct: {
            name: getLineItemName(contactLensesProduct, intl),
            specs: filterEmptySpecs(leftLens),
        }, rightEyeProduct: {
            name: getLineItemName(contactLensesProduct, intl),
            specs: filterEmptySpecs(rightLens),
        } }, solutionProperties);
};

var getSharedProps = function (lineItemRaw, product, settings, intl) {
    var variant = product.masterData.current.variant;
    return {
        allowBackOrder: getAllowBackOrder(variant),
        availability: getLineItemAvailability(variant.availability),
        currency: intl.currency,
        discount: getLineItemDiscount(lineItemRaw.discounts, lineItemRaw.price, intl.locale),
        id: lineItemRaw.id,
        imageUrl: settings.getItemImageUrl
            ? settings.getItemImageUrl(lineItemRaw)
            : getLineItemImageUrl(variant, settings.staticsUrl),
        isGift: lineItemRaw.isGift,
        name: getLineItemName(product, intl),
        price: getLineItemPrice(lineItemRaw.price),
        quantity: lineItemRaw.quantity,
    };
};

/**
 * We're doing a localeCompore to catch some casing differences we've encountered
 * in the past when receiving product data from the backend.
 */
function findBundledLineItem(lineItems, productType) {
    return lineItems.find(function (lineItem) {
        return lineItem.legacyProduct.productType.localeCompare(productType, 'en', {
            sensitivity: 'base',
            usage: 'search',
        }) === 0;
    });
}

function getBundledLineItemProductVariant(bundleLineItem) {
    return bundleLineItem.legacyProduct.masterData.current.variant;
}

function getBundledProductInfo(bundleLineItem, intl) {
    var name = bundleLineItem.legacyProduct.masterData.current.name;
    var variant = getBundledLineItemProductVariant(bundleLineItem);
    var variationAttribute = getAttribute(variant, 'variationAttribute');
    var variationAttributeValue = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getLocalizedAttrValue */ "o"])(variant, variationAttribute, intl.locale);
    var bundleTitle = getLocalizedString(intl.locale, name);
    return __assign({ sku: variant.sku, title: !!variationAttributeValue ? bundleTitle + " - " + variationAttributeValue : bundleTitle }, (bundleLineItem.price
        ? {
            price: getLineItemPrice(bundleLineItem.price).unit,
            discount: getLineItemDiscount(bundleLineItem.discounts, bundleLineItem.price, intl.locale),
        }
        : {}));
}

function getBundledFrameInfo(lineItemRaw, bundleLineItem, settings, intl) {
    var variant = getBundledLineItemProductVariant(bundleLineItem);
    var brandName = getAttribute(variant, 'brand');
    var model = getAttribute(variant, 'brandModel');
    var modelCode = getAttribute(variant, 'brandModelCode');
    var modelColorCode = getAttribute(variant, 'brandModelColorCode');
    var title = __spread(new Set([brandName, model, modelCode, modelColorCode].filter(Boolean))).join(' ');
    return __assign(__assign({}, getBundledProductInfo(bundleLineItem, intl)), { title: title, productId: lineItemRaw.id, brand: {
            name: brandName,
            model: model,
            modelCode: modelCode,
        } });
}

/**
 * getLensDetails
 *
 * Removes all null values and __typename from the lens object
 */
var getLensDetails = function (lens) {
    return Object.entries(lens).reduce(function (acc, _a) {
        var _b = __read(_a, 2), name = _b[0], value = _b[1];
        if (value !== null && name !== '__typename') {
            acc[name] = value;
        }
        return acc;
    }, {});
};

function getPrescription(typeDetails) {
    if (typeDetails.isEmailPrescription) {
        return {
            type: 'EmailPrescription',
        };
    }
    if (typeDetails.isExistingCustomer) {
        return {
            type: 'ExistingCustomer',
        };
    }
    if (typeDetails.newPrescription) {
        return {
            type: 'NewPrescription',
            rightLens: getLensDetails(typeDetails.newPrescription.rightLens),
            leftLens: getLensDetails(typeDetails.newPrescription.leftLens),
        };
    }
    return {
        type: 'PrescriptionFile',
    };
}

function getLineItemCartDiscountDescription(lineItemRaw, locale) {
    var discounts = lineItemRaw.discounts;
    if (!discounts || discounts.length === 0) {
        return;
    }
    var cartDiscounts = discounts === null || discounts === void 0 ? void 0 : discounts.filter(function (discount) { return discount.type === 'CartDiscount'; });
    if (!cartDiscounts.length) {
        return;
    }
    return getLocalizedString(locale, cartDiscounts[0].description);
}

var mapPrescriptionGlassesLineItem = function (lineItemRaw, settings, intl) {
    var _a, _b, _c, _d;
    var mainBundleLineItem = lineItemRaw.bundleLineItems.find(function (bundleLineItem) { return bundleLineItem.isMainBundleLineItem; });
    if (!mainBundleLineItem) {
        console.error("None of the bundleLineItems have isMainBundleLineItem in LineItemBundle with id " + lineItemRaw.id);
        return null;
    }
    var lensTypeBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'LensTypes');
    var lensPackageBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'PrescriptionGlassPackages');
    if (!lensTypeBundleLineItem || !lensPackageBundleLineItem) {
        console.error("Either lensTypeBundleLineItem or lensPackageBundleLineItem are missing from LineItemBundle with id " + lineItemRaw.id);
        return null;
    }
    var prescriptionTypeDetails = lineItemRaw.typeDetails;
    var addOnBundleLineItem = findBundledLineItem(lineItemRaw.bundleLineItems, 'PrescriptionGlassPackageOptions');
    var shared = getSharedProps(lineItemRaw, mainBundleLineItem.legacyProduct, settings, intl);
    // Assumes the frame is the main bundled line item
    var frame = getBundledFrameInfo(lineItemRaw, mainBundleLineItem, settings, intl);
    var lensType = getBundledProductInfo(lensTypeBundleLineItem, intl);
    var lensPackage = getBundledProductInfo(lensPackageBundleLineItem, intl);
    var addOn = !!addOnBundleLineItem ? getBundledProductInfo(addOnBundleLineItem, intl) : undefined;
    // Product discounts
    var frameDiscount = ((_a = frame.price) === null || _a === void 0 ? void 0 : _a.discount) || 0;
    var lensTypeDiscount = ((_b = lensType.price) === null || _b === void 0 ? void 0 : _b.discount) || 0;
    var lensPackageDiscount = ((_c = lensPackage.price) === null || _c === void 0 ? void 0 : _c.discount) || 0;
    var addOnDiscount = ((_d = addOn === null || addOn === void 0 ? void 0 : addOn.price) === null || _d === void 0 ? void 0 : _d.discount) || 0;
    var totalProductDiscount = shared.quantity * (frameDiscount + lensTypeDiscount + lensPackageDiscount + addOnDiscount);
    // Total discount (cart discount + (all product discounts * quantity))
    var totalDiscount = shared.price.total.discount;
    var slug = getLocalizedString(intl.locale, mainBundleLineItem.legacyProduct.masterData.current.slug);
    return __assign(__assign(__assign({}, shared), { type: 'prescription-glasses', name: frame.title, frame: frame,
        lensType: lensType,
        lensPackage: lensPackage,
        addOn: addOn, productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale), prescription: getPrescription(prescriptionTypeDetails) }), (!!totalDiscount
        ? {
            cartDiscount: {
                amount: totalDiscount - totalProductDiscount,
                description: getLineItemCartDiscountDescription(lineItemRaw, intl.locale),
            },
        }
        : {}));
};

var mapBundleProduct = function (lineItemRaw, settings, intl) {
    switch (lineItemRaw.bundleLineItemsType) {
        case BundleLineItemType.CONTACT_LENSES_BENELUX:
            return mapContactLensesBundleBeneluxLineItem(lineItemRaw, settings, intl);
        case BundleLineItemType.PRESCRIPTION_GLASSES:
            return mapPrescriptionGlassesLineItem(lineItemRaw, settings, intl);
        default:
            console.log("Encountered unsupported BundleLineItemType '" + lineItemRaw.bundleLineItemsType + "' with sku " + lineItemRaw.sku + " ");
            return null;
    }
};

var getEyeSide = function (typeDetails) {
    if (typeDetails && 'eyeSide' in typeDetails && typeDetails.eyeSide) {
        return typeDetails.eyeSide.toLowerCase();
    }
    return;
};

var getLocalizedAttributes = function (variant, attrName, locale) {
    var attrValues = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getAttrValue */ "m"])(variant, attrName);
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isPlainObject */ "A"])(attrValues)) {
        return [Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getLocalizedValue */ "q"])(attrValues, locale)];
    }
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isArray */ "v"])(attrValues)) {
        return attrValues.map(function (attrValue) {
            return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getLocalizedValue */ "q"])(attrValue, locale);
        });
    }
    return [];
};

var mapRegularProduct = function (lineItemRaw, settings, intl) {
    var product = lineItemRaw.legacyProduct;
    var variant = product.masterData.current.variant;
    var shared = getSharedProps(lineItemRaw, product, settings, intl);
    var slug = getLocalizedString(intl.locale, product.masterData.current.slug);
    var productAttributes = {
        sku: lineItemRaw.sku,
        productSlug: slug,
        productId: product.id,
        productUrl: getProductUrl(settings.formatProductUrl, lineItemRaw, slug, intl.locale),
        brand: {
            name: getAttribute(variant, 'brand'),
            model: getAttribute(variant, 'brandModel'),
            modelCode: getAttribute(variant, 'brandModelCode'),
        },
    };
    switch (product.productType) {
        case 'solutions':
            return __assign(__assign(__assign({ type: 'solutions' }, shared), productAttributes), { solutionType: getAttribute(variant, 'solutionType'), solutionVolume: getAttribute(variant, 'volume') });
        case 'contact-lenses':
            return __assign(__assign(__assign({ type: 'contact-lenses' }, shared), productAttributes), { eyeSide: getEyeSide(lineItemRaw.typeDetails), colorLens: getAttribute(variant, 'color'), replacementFrequency: getLocalizedAttribute(variant, 'replacementFrequency', intl.locale), packageQuantity: getAttribute(variant, 'packageQuantity'), specs: getContactLensSpecs(variant.attributes), sapArticleNumber: getAttribute(variant, 'sapArticleNumber') });
        case 'sunglasses':
            return __assign(__assign(__assign({ type: 'sunglasses' }, shared), productAttributes), { frame: {
                    frameShape: getAttribute(variant, 'frameShape'),
                    frameMaterial: getLocalizedAttributes(variant, 'frameMaterial', intl.locale),
                    frameColor: getLocalizedAttributes(variant, 'frameColor', intl.locale),
                } });
        default:
            console.log("Encountered unsupported productType '" + product.productType + "' with sku '" + variant.sku + "'");
            return null;
    }
};
var lineItemDataMapper = function (lineItemsRaw, settings, intl) {
    var lineItems = lineItemsRaw.map(function (lineItemRaw) {
        switch (lineItemRaw.__typename) {
            case 'LineItemBundle':
                return mapBundleProduct(lineItemRaw, settings, intl);
            case 'LineItemContactLenses':
            case 'LineItemRegular':
                return mapRegularProduct(lineItemRaw, settings, intl);
        }
    });
    return lineItems.filter(function (lineItem) { return Boolean(lineItem); });
};

var CART_STORAGE_KEY = 'stored_cart';
var initialState = {
    cartId: null,
    cartCount: 0,
};
var useCartStorage = function () {
    var _a = __read(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* useLocalStorage */ "L"])(CART_STORAGE_KEY, initialState), 2), data = _a[0], setData = _a[1];
    var setCartId = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (cartId) {
        setData(function (state) { return (__assign(__assign({}, state), { cartId: cartId })); });
    }, []);
    var setCartCount = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (newCount) {
        if (cartCountVar() !== newCount) {
            cartCountVar(newCount);
        }
        return setData(function (state) {
            if (state.cartCount === newCount) {
                return state;
            }
            return __assign(__assign({}, state), { cartCount: newCount });
        });
    }, []);
    var reset = function () {
        setData(initialState);
    };
    return [data, { setCartId: setCartId, setCartCount: setCartCount, reset: reset }];
};

var useGetCart = function () {
    var _a = __read(useCartStorage(), 2), cart = _a[0], _b = _a[1], setCartCount = _b.setCartCount, reset = _b.reset;
    var cartIdRef = Object(react__WEBPACK_IMPORTED_MODULE_0__["useRef"])(cart.cartId);
    var onValidationError = function (validationCodes) {
        validationCodes.forEach(function (code) { return _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].failed("cart." + code); });
    };
    var _c = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useLazyQuery */ "e"])(GET_CART, {
        onCompleted: function (data) {
            if (!data.getCart.validationErrors) {
                setCartCount(data.getCart.cart.numberOfItems);
            }
            else {
                var validationErrorCodes = getValidationErrorCodes(data.getCart.validationErrors);
                onValidationError && onValidationError(validationErrorCodes);
                reset();
            }
        },
        onError: function () {
            reset();
        },
    }), 2), getCart = _c[0], _d = _c[1], called = _d.called, loading = _d.loading, data = _d.data, error = _d.error;
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
        if (cartIdRef.current) {
            getCart({ variables: { id: cartIdRef.current } });
        }
    }, [getCart]);
    return { called: called, loading: loading, data: !!cart.cartId ? data : null, error: error };
};

var CartSettingsContext = Object(react__WEBPACK_IMPORTED_MODULE_0__["createContext"])(null);
CartSettingsContext.displayName = 'CartSettings';
var useCartSettings = function () {
    var context = Object(react__WEBPACK_IMPORTED_MODULE_0__["useContext"])(CartSettingsContext);
    if (context === null) {
        throw new Error('Missing CartSettings provider. You have to wrap the application with the CartSettingsProvider component from the @grandvision/carts-v2 package.');
    }
    return context;
};

var defaultSettings = {
    allowBackOrder: true,
    hideStockAndDeliveryOnLineItem: false,
    multiDiscountType: false,
    showSubTotal: true,
    showTotalDiscount: true,
    showCartDiscountDescriptions: true,
    isDiscountCodeEnabled: false,
};
var CartSettingsProvider = function (_a) {
    var children = _a.children, settings = _a.settings;
    var value = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return (__assign(__assign({}, defaultSettings), settings)); }, [settings]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartSettingsContext.Provider, { value: value }, children);
};

var CartProvider = function (_a) {
    var children = _a.children;
    var _b = useGetCart(), called = _b.called, loading = _b.loading, data = _b.data, error = _b.error;
    var settings = useCartSettings();
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])();
    var cart = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
        if (data === null) {
            return null;
        }
        if (!data) {
            return undefined;
        }
        var lineItemsRaw = data.getCart.cart.lineItems;
        return {
            id: data.getCart.cart.id,
            numberOfItems: data.getCart.cart.numberOfItems,
            lineItems: lineItemDataMapper(lineItemsRaw, settings, intl),
            prices: cartPriceMapper(data.getCart.cart.price),
            discountDescriptions: getDiscountDescriptions(data.getCart.cart.appliedDiscounts, intl.locale),
            voucherCodes: getActiveVoucherCodes(data.getCart.cart.vouchers),
        };
    }, [data, intl, settings]);
    var value = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({ cart: cart, loading: loading, error: error, called: called }); }, [
        cart,
        called,
        loading,
        error,
    ]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartContext.Provider, { value: value }, children);
};



var index$4 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useCart: useCart,
  CartProvider: CartProvider,
  useCartSettings: useCartSettings,
  CartSettingsProvider: CartSettingsProvider
});

var errorsMapping = {
    CART_IS_EMPTY: 'errors.cartIsEmpty',
    MISSING_CART_ID: 'errors.missingCartID',
    SOMETHING_WENT_WRONG: 'errors.somethingWentWrong',
    CART_NOT_FOUND: 'errors.cartNotFound',
};

var mapContactLensesLineItem = function (_a) {
    var sku = _a.sku, quantity = _a.quantity, typeDetails = _a.typeDetails;
    var eyeSide = typeDetails.eyeSide, prescriptionExpiryDate = typeDetails.prescriptionExpiryDate, prescriptionExamDate = typeDetails.prescriptionExamDate, internalOptician = typeDetails.internalOptician, externalOptician = typeDetails.externalOptician;
    return {
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.CONTACTLENSES,
        typeDetails: {
            eyeSide: eyeSide === 'left' ? EyeSide.LEFT : EyeSide.RIGHT,
            prescriptionExpiryDate: prescriptionExpiryDate,
            prescriptionExamDate: prescriptionExamDate,
            internalOptician: internalOptician,
            externalOptician: externalOptician,
        },
    };
};

var mapContactLensesBundleBeneluxLineItem$1 = function (_a) {
    var sku = _a.sku, quantity = _a.quantity, typeDetails = _a.typeDetails;
    var leftLensBaseCurve = typeDetails.leftLensBaseCurve, leftLensDiameter = typeDetails.leftLensDiameter, leftLensPower = typeDetails.leftLensPower, leftLensAxis = typeDetails.leftLensAxis, leftLensCylinder = typeDetails.leftLensCylinder;
    var rightLensBaseCurve = typeDetails.rightLensBaseCurve, rightLensDiameter = typeDetails.rightLensDiameter, rightLensPower = typeDetails.rightLensPower, rightLensAxis = typeDetails.rightLensAxis, rightLensCylinder = typeDetails.rightLensCylinder;
    return {
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.CONTACT_LENSES_BENELUX,
        typeDetails: {
            prescription: {
                rightLens: {
                    baseCurve: rightLensBaseCurve,
                    diameter: rightLensDiameter,
                    power: rightLensPower,
                    axis: rightLensAxis,
                    cylinder: rightLensCylinder,
                },
                leftLens: {
                    baseCurve: leftLensBaseCurve,
                    diameter: leftLensDiameter,
                    power: leftLensPower,
                    axis: leftLensAxis,
                    cylinder: leftLensCylinder,
                },
            },
        },
    };
};

function getPrescriptionGlassesDetails(prescription) {
    switch (prescription.type) {
        case 'email-prescription':
            return {
                isEmailPrescription: true,
            };
        case 'existing-customer':
            return {
                isExistingCustomer: true,
            };
        case 'new-prescription':
            return {
                newPrescription: __assign({}, prescription.details),
            };
    }
}
var mapPrescriptionGlassesLineItem$1 = function (_a) {
    var sku = _a.sku, quantity = _a.quantity, bundleLineItems = _a.bundleLineItems, prescription = _a.prescription;
    var mainBundleLineItem = {
        sku: sku,
        quantity: 1,
        isMainBundleLineItem: true,
    };
    return {
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.BUNDLE,
        bundleLineItemsType: BundleLineItemType.PRESCRIPTION_GLASSES,
        bundleLineItems: __spread([
            mainBundleLineItem
        ], bundleLineItems.map(function (item) {
            var _a;
            return (__assign(__assign({}, item), { quantity: (_a = item.quantity) !== null && _a !== void 0 ? _a : 1, isMainBundleLineItem: false }));
        })),
        typeDetails: getPrescriptionGlassesDetails(prescription),
    };
};

var mapRegularLineItem = function (_a) {
    var sku = _a.sku, quantity = _a.quantity;
    return ({
        sku: sku,
        quantity: quantity !== null && quantity !== void 0 ? quantity : 1,
        lineItemType: LineItemType.REGULAR,
    });
};

// Map line items to the server model
var mapDraftLineItemToServer = function (lineItemDraft) {
    switch (lineItemDraft.type) {
        case 'contact-lenses':
            return mapContactLensesLineItem(lineItemDraft);
        case 'contact-lenses-bundle-benelux':
            return mapContactLensesBundleBeneluxLineItem$1(lineItemDraft);
        case 'prescription-glasses':
            return mapPrescriptionGlassesLineItem$1(lineItemDraft);
        case 'regular':
            return mapRegularLineItem(lineItemDraft);
    }
};

var miniCartEventType = 'mini-cart';
var dispatchMiniCartEvent = function (type, lineItems) {
    if (window) {
        window.dispatchEvent(new CustomEvent(miniCartEventType, {
            detail: {
                type: type,
                lineItems: lineItems,
            },
        }));
    }
};
var useMiniCartListener = function (handler) {
    return Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* useEventListener */ "J"])(miniCartEventType, handler);
};

var useAddToCart = function () {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])();
    var locale = intl.locale, currency = intl.currency, country = intl.country;
    var settings = useCartSettings();
    var _a = __read(useCartStorage(), 2), cart = _a[0], _b = _a[1], setCartId = _b.setCartId, setCartCount = _b.setCartCount;
    var _c = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useMutation */ "f"])(CREATE_CART), 2), createCart = _c[0], createCartMutation = _c[1];
    var _d = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useMutation */ "f"])(ADD_CART_LINE_ITEMS), 2), addCartLineItems = _d[0], addCartLineItemsMutation = _d[1];
    var handleOnCompleted = function (addedLineItemDrafts, data, onError, onSuccess, onValidationError) {
        var result;
        if ('addCartLineItems' in data) {
            result = data.addCartLineItems;
        }
        if ('createCart' in data) {
            result = data.createCart;
        }
        if (!result.success) {
            var validationErrors = getValidationErrorCodes(result.validationErrors);
            onValidationError && onValidationError(validationErrors);
            return;
        }
        if (!result.cart) {
            return onError(errorsMapping.CART_IS_EMPTY);
        }
        var _a = result.cart, id = _a.id, numberOfItems = _a.numberOfItems, lineItems = _a.lineItems;
        setCartId(id);
        setCartCount(numberOfItems);
        var addedLineItems = getAddedLineItems(lineItems, addedLineItemDrafts);
        var addedLineItemsMapped = lineItemDataMapper(addedLineItems, settings, intl);
        var SdProductObjects = addedLineItemsMapped.map(function (lineItem) { return createProductObject(lineItem); });
        dispatchMiniCartEvent('added', addedLineItemsMapped);
        _grandvision_analytics__WEBPACK_IMPORTED_MODULE_5__[/* CartV2Actions */ "f"].addToCartSdAction(SdProductObjects);
        onSuccess && onSuccess(addedLineItemsMapped);
    };
    var addToCart = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (lineItemDrafts, onSuccess, onValidationError, onError) {
        if (onError === void 0) { onError = function () { return undefined; }; }
        return __awaiter(void 0, void 0, void 0, function () {
            var lineItems, _a, data_1, errors, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        lineItems = lineItemDrafts.map(mapDraftLineItemToServer);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (cart.cartId
                                ? addCartLineItems({
                                    variables: {
                                        cartInput: {
                                            cartId: cart.cartId,
                                            lineItems: lineItems,
                                        },
                                    },
                                })
                                : createCart({
                                    variables: {
                                        cartInput: {
                                            locale: locale,
                                            currency: currency,
                                            country: country,
                                            lineItems: lineItems,
                                        },
                                    },
                                }))];
                    case 2:
                        _a = _b.sent(), data_1 = _a.data, errors = _a.errors;
                        if (errors) {
                            onError(errorsMapping.SOMETHING_WENT_WRONG);
                        }
                        if (data_1) {
                            handleOnCompleted(lineItemDrafts, data_1, onError, onSuccess, onValidationError);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        onError(errorsMapping.SOMETHING_WENT_WRONG);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }, [cart]);
    var _e = cart.cartId
        ? addCartLineItemsMutation
        : createCartMutation, called = _e.called, loading = _e.loading, error = _e.error, data = _e.data;
    var newCart;
    if (data && 'createCart' in data) {
        newCart = data.createCart.cart;
    }
    if (data && 'addCartLineItems' in data) {
        newCart = data.addCartLineItems.cart;
    }
    return [addToCart, { called: called, loading: loading, error: error, cart: newCart }];
};

var useRemoveFromCart = function (lineItem, onSuccess) {
    var _a = __read(useCartStorage(), 2), cartId = _a[0].cartId, setCartCount = _a[1].setCartCount;
    var _b = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useMutation */ "f"])(REMOVE_CART_LINE_ITEMS, {
        onCompleted: function () {
            _grandvision_analytics__WEBPACK_IMPORTED_MODULE_5__[/* CartV2Actions */ "f"].removeLineItemsSdAction([createProductObject(lineItem)]);
            onSuccess && onSuccess();
        },
    }), 2), removeCartItems = _b[0], removeCartLineItemsMutation = _b[1];
    var removeFromCart = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isNil */ "y"])(cartId)) {
            console.error('No cart ID available');
            return;
        }
        removeCartItems({
            variables: {
                cartInput: {
                    cartId: cartId,
                    lineItems: [
                        {
                            id: lineItem.id,
                        },
                    ],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                if (data && data.removeCartLineItems.success === true) {
                    var newCart = data.removeCartLineItems.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                    setCartCount((newCart === null || newCart === void 0 ? void 0 : newCart.numberOfItems) || 0);
                }
            },
        });
    }, [lineItem]);
    var called = removeCartLineItemsMutation.called, loading = removeCartLineItemsMutation.loading, error = removeCartLineItemsMutation.error;
    return [removeFromCart, { called: called, loading: loading, error: error }];
};

var useUpdateLineItemQuantity = function (lineItem) {
    var _a = __read(useCartStorage(), 2), cartId = _a[0].cartId, setCartCount = _a[1].setCartCount;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(''), 2), updateType = _b[0], setUpdateType = _b[1];
    var handleValidationErrors = function (validationErrors) {
        validationErrors.forEach(function (validationError) { return _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].failed("cart." + validationError); });
    };
    var _c = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useMutation */ "f"])(UPDATE_CART_LINE_ITEMS, {
        onCompleted: function () {
            _grandvision_analytics__WEBPACK_IMPORTED_MODULE_5__[/* CartV2Actions */ "f"].updateQuantitySdAction([
                {
                    object: createProductObject(lineItem),
                    updateType: updateType,
                },
            ]);
        },
    }), 2), updateCartItems = _c[0], updateQuantityMutation = _c[1];
    var updateItemQuantity = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (updatedQuantity, updateType) {
        if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isNil */ "y"])(cartId)) {
            console.error('No cart ID available');
            return;
        }
        updateCartItems({
            variables: {
                cartInput: {
                    cartId: cartId,
                    lineItems: [
                        {
                            id: lineItem.id,
                            quantity: updatedQuantity,
                        },
                    ],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                setUpdateType(updateType);
                if (data && data.updateCartLineItems.success === true) {
                    var newCart = data.updateCartLineItems.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                    setCartCount((newCart === null || newCart === void 0 ? void 0 : newCart.numberOfItems) || 0);
                }
                if (data && !data.updateCartLineItems.success) {
                    var validationErrors = getValidationErrorCodes(data.updateCartLineItems.validationErrors);
                    handleValidationErrors(validationErrors);
                }
            },
        });
    }, [lineItem.id]);
    var called = updateQuantityMutation.called, loading = updateQuantityMutation.loading, error = updateQuantityMutation.error;
    return [updateItemQuantity, { called: called, loading: loading, error: error }];
};



var index$5 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  useAddToCart: useAddToCart,
  useCartStorage: useCartStorage,
  useGetCart: useGetCart,
  useRemoveFromCart: useRemoveFromCart,
  useUpdateLineItemQuantity: useUpdateLineItemQuantity
});



var index$6 = /*#__PURE__*/Object.freeze({
  __proto__: null
});

var AddToCart = function (props) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], __assign({ size: "custom", "data-t": "add-to-cart", className: "add-to-cart" }, props))); };

var AddToCartContainer = function (_a) {
    var lineItemDrafts = _a.lineItemDrafts, onSuccess = _a.onSuccess, buttonProps = __rest(_a, ["lineItemDrafts", "onSuccess"]);
    var onValidationError = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (validationCodes) {
        validationCodes.forEach(function (code) { return _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].failed("cart." + code); });
    }, []);
    var onError = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (errorCode) {
        _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].failed("cart." + errorCode);
    }, []);
    var handleSuccess = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (addedLineItems) {
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(addedLineItems);
    }, [onSuccess]);
    var _b = __read(useAddToCart(), 2), addToCart = _b[0], loading = _b[1].loading;
    var handleOnClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () { return addToCart(lineItemDrafts, handleSuccess, onValidationError, onError); }, [addToCart, lineItemDrafts, handleSuccess, onValidationError, onError]);
    if (!lineItemDrafts.length) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(AddToCart, __assign({ onClick: handleOnClick, disabled: loading || buttonProps.disabled }, buttonProps)));
};

var AddToCart$1 = function (props) { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(AddToCartContainer, __assign({}, props)); };

var EmptyCart = function (_a) {
    var labels = _a.labels, onClick = _a.onClick;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "cart", "data-t": "empty-cart" },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { variant: "large" }, labels.cartTitle),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "cart__empty-message" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { component: "h2", variant: "small" }, labels.emptyCartTitle),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { variant: "body" }, labels.emptyCartMessage),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], { className: "cart__button cart__empty-message-button", color: "primary", caption: labels.buttonCaption, onClick: onClick, "aria-label": labels.buttonCaption }))));
};

var goBack = function () {
    if (document.referrer === window.location.href) {
        window.location.href = '/';
    }
    window.location.host === document.referrer.split('/')[2]
        ? window.history.back()
        : (window.location.href = '/');
};

var EmptyCartContainer = function (_a) {
    var _b = _a.onClick, onClick = _b === void 0 ? goBack : _b;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])();
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        cartTitle: intl.getLabel('cart.title'),
        emptyCartTitle: intl.getLabel('cart.emptyCart.title'),
        emptyCartMessage: intl.getLabel('cart.emptyCart.message'),
        buttonCaption: intl.getLabel('cart.actions.goBack'),
    }); }, [intl.locale]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(EmptyCart, { labels: labels, onClick: onClick });
};

var EmptyCart$1 = function (props) { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(EmptyCartContainer, __assign({}, props)); };

var DiscountDescriptions = function (_a) {
    var descriptions = _a.descriptions, labels = _a.labels;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__discount-descriptions" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Alert */ "c"], { type: "info", title: labels.promotionTitle, message: descriptions, className: "cart-totals__alert" })));
};

var DiscountDescriptionsContainer = function () {
    var settings = useCartSettings();
    var cart = useCart().cart;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        promotionTitle: getLabel('cart.cart.promotion.title'),
    }); }, [getLabel]);
    if (!settings.showCartDiscountDescriptions || !cart || !(cart.discountDescriptions.length > 0)) {
        return null;
    }
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(DiscountDescriptions, { descriptions: cart.discountDescriptions, labels: labels });
};

var DiscountDescriptions$1 = function () { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(DiscountDescriptionsContainer, null); };

var RemoveVoucherCodeContainer = function (_a) {
    var voucherCode = _a.voucherCode, dataT = _a["data-t"];
    var _b = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useMutation */ "f"])(REMOVE_CART_VOUCHER_CODES), 1), removeCartVoucherCodes = _b[0];
    var _c = __read(useCartStorage(), 1), cartId = _c[0].cartId;
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isNil */ "y"])(cartId) || !voucherCode) {
        return null;
    }
    var handleRemove = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        removeCartVoucherCodes({
            variables: {
                cartInput: {
                    cartId: cartId,
                    voucherCodes: [voucherCode],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                if (data && data.removeCartVoucherCodes.success === true) {
                    var newCart = data.removeCartVoucherCodes.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                }
            },
        });
    }, [voucherCode]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-pricing-details__row", key: voucherCode },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "cart-pricing-details__label" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart__applied-discount" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "cart__applied-discount-code" }, voucherCode),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* IconButton */ "w"], { className: "cart__applied-discount-button", onClick: handleRemove, "data-t": dataT },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "b"], { className: "cart__applied-discount-icon", name: "close", width: 12, height: 12 })))),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "cart-pricing-details__value" })));
};

var VoucherCodeFormContainer = function (_a) {
    var dataT = _a["data-t"];
    var _b = __read(useCartStorage(), 1), cartId = _b[0].cartId;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    if (Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isNil */ "y"])(cartId)) {
        return null;
    }
    var handleError = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].failed('cart.validations.discountcode.notvalid');
    }, []);
    var _c = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useMutation */ "f"])(ADD_CART_VOUCHER_CODES, { onError: handleError }), 1), addCartVoucherCodes = _c[0];
    var handleSubmit = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (inputValue) {
        addCartVoucherCodes({
            variables: {
                cartInput: {
                    cartId: cartId,
                    voucherCodes: [inputValue],
                },
            },
            update: function (cache, _a) {
                var data = _a.data;
                if (data && data.addCartVoucherCodes.success === true) {
                    var newCart = data.addCartVoucherCodes.cart;
                    cache.writeQuery({
                        query: GET_CART,
                        variables: { id: cartId },
                        data: newCart,
                    });
                    _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].success('cart.validations.discountcode.matchescart');
                }
            },
        });
    }, [cartId]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_forms__WEBPACK_IMPORTED_MODULE_10__[/* DiscountCodeForm */ "g"], { content: {
            inputField: {
                inputId: 'discount-code',
                type: 'text',
            },
        }, onSubmit: handleSubmit, placeholderLabel: getLabel('cart.discountForm.placeholder'), buttonCaptionLabel: getLabel('cart.discountForm.cta'), "data-t": dataT }));
};

var VoucherCodeForm = function () { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(VoucherCodeFormContainer, null); };

var RemoveVoucherCode = function (props) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveVoucherCodeContainer, __assign({}, props))); };

var Totals = function (_a) {
    var className = _a.className, currency = _a.currency, labels = _a.labels, prices = _a.prices, settings = _a.settings, voucherCodes = _a.voucherCodes;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('cart-totals', className) },
        settings.showSubTotal && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__row" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__label" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span" }, labels.subTotal)),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__value" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: prices.subTotalPrice, currency: currency })))),
        settings.showTotalDiscount && prices.discountPrice !== 0 && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__row" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__label" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span" }, labels.totalDiscount)),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__value cart-totals__value--discount" },
                "- ",
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: prices.discountPrice, currency: currency })))),
        voucherCodes &&
            voucherCodes.map(function (code) { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveVoucherCode, { key: code, voucherCode: code }); }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__row" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__label" }, labels.delivery),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__value" }, prices.shippingPrice > 0 ? (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: prices.shippingPrice, currency: currency })) : (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span" }, labels.freeDelivery)))),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__row cart-totals__row--total-price" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__label" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { variant: "body-head" }, labels.total)),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-totals__value" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: prices.totalPrice, currency: currency, className: "cart-totals__total-price" })))));
};

var TotalsContainer = function (_a) {
    var showSubTotal = _a.showSubTotal, showTotalDiscount = _a.showTotalDiscount, className = _a.className;
    var settings = useCartSettings();
    var cart = useCart().cart;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])(), currency = _b.currency, getLabel = _b.getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        delivery: getLabel('cart.delivery'),
        freeDelivery: getLabel('cart.delivery.forFree'),
        subTotal: getLabel('cart.value.subTotal'),
        total: getLabel('cart.value.total'),
        totalDiscount: getLabel('cart.value.totalDiscount'),
    }); }, [getLabel]);
    if (!cart) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Totals, { className: className, currency: currency, labels: labels, prices: cart.prices, settings: __assign(__assign({}, settings), { showSubTotal: !Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isNil */ "y"])(showSubTotal) ? showSubTotal : settings.showSubTotal, showTotalDiscount: !Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isNil */ "y"])(showTotalDiscount)
                ? showTotalDiscount
                : settings.showTotalDiscount }), voucherCodes: cart.voucherCodes }));
};

var Totals$1 = function (props) { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(TotalsContainer, __assign({}, props)); };

var Navigation = function (_a) {
    var labels = _a.labels, goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-navigation" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], { className: "cart-navigation__button", "data-t": "cart-go-back", caption: labels.goBack, variant: "outline", onClick: goToPreviousPage }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], { className: "cart-navigation__button", "data-t": "cart-go-to-checkout", caption: labels.goToCheckout, onClick: goToCheckout })));
};

var NavigationContainer = function (props) {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        goBack: getLabel('cart.actions.goBack'),
        goToCheckout: getLabel('cart.actions.goToCheckout'),
    }); }, [getLabel]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Navigation, __assign({}, props, { labels: labels }));
};

var Footer = function (_a) {
    var goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage, readOnly = _a.readOnly;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-footer" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-footer__aside" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(DiscountDescriptions$1, null)),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-footer__main" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-footer__voucher-form" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(VoucherCodeForm, null)),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Totals$1, null)),
        !readOnly && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart-footer__navigation" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(NavigationContainer, { goToCheckout: goToCheckout, goToPreviousPage: goToPreviousPage })))));
};

var ContactLensMetaData = function (_a) {
    var colorLens = _a.colorLens, replacementFrequency = _a.replacementFrequency, packageQuantity = _a.packageQuantity, labels = _a.labels;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__contact-lens-meta" },
        colorLens && Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__contact-lens-meta-value" }, colorLens),
        replacementFrequency && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__contact-lens-meta-value" }, replacementFrequency)),
        packageQuantity && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__contact-lens-meta-value" }, packageQuantity + " " + labels.productsUnitContactLenses + " " + labels.productsPerBox))));
};

var ContactLensSpecs = function (_a) {
    var specs = _a.specs, labels = _a.labels, isTabletLandscapeUp = _a.isTabletLandscapeUp;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__spec-box" }, specs.map(function (spec) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__spec", key: spec.name },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__spec-label" }, isTabletLandscapeUp ? labels[spec.name] : labels[spec.name + "Abbr"]),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__spec-value" },
            spec.value,
            " "))); })));
};

var Discount = function (_a) {
    var absoluteValue = _a.absoluteValue, relativeValue = _a.relativeValue, currency = _a.currency, labels = _a.labels, className = _a.className;
    var hasAbsoluteValue = absoluteValue > 0;
    var hasRelativeValue = (relativeValue !== null && relativeValue !== void 0 ? relativeValue : 0) > 0;
    if (!hasAbsoluteValue && !hasRelativeValue) {
        return null;
    }
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('line-item__discount', className) },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "line-item__discount-text" },
            labels.discount,
            "\u00A0"),
        hasRelativeValue ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "line-item__discount-value" },
            relativeValue,
            "%")) : (hasAbsoluteValue && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: absoluteValue, currency: currency, className: "line-item__discount-price" })))));
};

var Prices = function (_a) {
    var _b;
    var currency = _a.currency, discount = _a.discount, labels = _a.labels, _c = _a.orientation, orientation = _c === void 0 ? 'vertical' : _c, originalPrice = _a.originalPrice, totalPrice = _a.totalPrice;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('line-item__prices', (_b = {},
            _b["line-item__prices--discount line-item__prices--" + orientation] = discount > 0,
            _b)) },
        originalPrice !== 0 ? (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: originalPrice, currency: currency, className: classnames__WEBPACK_IMPORTED_MODULE_7___default()({ 'line-item__prices-discount-amount': discount > 0 }) })) : (labels.freeProduct),
        discount > 0 && react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: totalPrice, currency: currency, type: "default", size: "custom" })));
};

var Image = function (_a) {
    var imageUrl = _a.imageUrl, imageAlt = _a.imageAlt;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("img", { className: "prescription-glasses-line-item-image__image", src: imageUrl, alt: imageAlt }));
};
var PrescriptionGlassesLineItemImage = function (_a) {
    var className = _a.className, href = _a.href, rest = __rest(_a, ["className", "href"]);
    var sharedProps = {
        className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('prescription-glasses-line-item-image', className),
        'data-t': rest['data-t'],
    };
    return href ? (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("a", __assign({}, sharedProps, { href: href }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Image, __assign({}, rest)))) : (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", __assign({}, sharedProps),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Image, __assign({}, rest))));
};

var SolutionSpecs = function (_a) {
    var type = _a.type, volume = _a.volume, labels = _a.labels;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span" },
            type,
            ", "),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span" },
            volume,
            " ",
            labels.unit)));
};

var StockAndDelivery = function (_a) {
    var readOnly = _a.readOnly, availableQuantity = _a.availableQuantity, availability = _a.availability, deliveryResolver = _a.deliveryResolver, allowBackOrder = _a.allowBackOrder, stockResolver = _a.stockResolver, hideStockAndDeliveryOnLineItem = _a.hideStockAndDeliveryOnLineItem;
    return !readOnly && !hideStockAndDeliveryOnLineItem ? (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__stock-and-delivery" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__delivery" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__[/* DeliveryIndicator */ "a"], { view: "short", availability: availability ? [availability] : [], deliveryResolver: deliveryResolver })),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__stock" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__[/* StockIndicator */ "d"], { allowBackOrder: allowBackOrder, stockCount: availableQuantity, stockResolver: stockResolver })))) : null;
};

var ContactLensSpecsContainer = function (_a) {
    var colorLens = _a.colorLens, replacementFrequency = _a.replacementFrequency, packageQuantity = _a.packageQuantity, specs = _a.specs;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])(), locale = _b.locale, getLabel = _b.getLabel;
    var isTabletLandscapeUp = _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].useBreakpoint() === _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE;
    var labels = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({
        productsUnitContactLenses: getLabel('products.unit.contactLenses'),
        productsPerBox: getLabel('products.perBox'),
        baseCurve: getLabel("products.contactLenses.prescription.baseCurve"),
        baseCurveAbbr: getLabel("products.contactLenses.prescription.baseCurve.abbr"),
        diameter: getLabel("products.contactLenses.prescription.diameter"),
        diameterAbbr: getLabel("products.contactLenses.prescription.diameter.abbr"),
        axis: getLabel("products.contactLenses.prescription.axis"),
        axisAbbr: getLabel("products.contactLenses.prescription.axis.abbr"),
        power: getLabel("products.contactLenses.prescription.power"),
        powerAbbr: getLabel("products.contactLenses.prescription.power.abbr"),
        cylinder: getLabel("products.contactLenses.prescription.cylinder"),
        cylinderAbbr: getLabel("products.contactLenses.prescription.cylinder.abbr"),
        addition: getLabel("products.contactLenses.prescription.addition"),
        additionAbbr: getLabel("products.contactLenses.prescription.addition.abbr"),
    }); }, [locale, getLabel]);
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ContactLensMetaData, { colorLens: colorLens, replacementFrequency: replacementFrequency, packageQuantity: packageQuantity, labels: labels }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ContactLensSpecs, { specs: specs, labels: labels, isTabletLandscapeUp: isTabletLandscapeUp })));
};

var DiscountContainer = function (_a) {
    var discount = _a.discount;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])(), currency = _b.currency, getLabel = _b.getLabel, locale = _b.locale;
    var settings = useCartSettings();
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        discount: getLabel('cart.item.discount'),
    }); }, [locale, getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Discount, { currency: currency, absoluteValue: discount.absoluteValue, relativeValue: settings.multiDiscountType ? discount.relativeValue : undefined, labels: labels }));
};

var PricesContainer = function (_a) {
    var discount = _a.discount, orientation = _a.orientation, originalPrice = _a.originalPrice, totalPrice = _a.totalPrice;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])(), currency = _b.currency, locale = _b.locale, getLabel = _b.getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        freeProduct: getLabel('products.freeProduct'),
    }); }, [locale, getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Prices, { currency: currency, discount: discount, orientation: orientation, originalPrice: originalPrice, totalPrice: totalPrice, labels: labels }));
};

var RemoveLineItemContainer = function (_a) {
    var lineItem = _a.lineItem;
    var _b = __read(useRemoveFromCart(lineItem), 1), removeFromCart = _b[0];
    var handleOnClick = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function () {
        removeFromCart();
    }, [lineItem]);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemDeleteButton */ "G"], { onClick: handleOnClick });
};

var SolutionSpecsContainer = function (_a) {
    var type = _a.type, volume = _a.volume;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])(), getLabel = _b.getLabel, locale = _b.locale;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        unit: getLabel('products.unit.metric.liter.milli.abbr'),
    }); }, [locale, getLabel]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(SolutionSpecs, { labels: labels, type: type, volume: volume });
};

var StockAndDeliveryContainer = function (_a) {
    var lineItem = _a.lineItem;
    var settings = useCartSettings();
    var deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory([lineItem]);
    var stockResolver = settings.stockResolverFactory && settings.stockResolverFactory(lineItem);
    var availableQuantity = _grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__[/* Helpers */ "c"].getAvailableQuantity(lineItem.availability);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(StockAndDelivery, { hideStockAndDeliveryOnLineItem: settings.hideStockAndDeliveryOnLineItem, readOnly: settings.readOnly, availableQuantity: availableQuantity, availability: lineItem.availability, deliveryResolver: deliveryResolver, allowBackOrder: Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isBoolean */ "w"])(lineItem.allowBackOrder) ? lineItem.allowBackOrder : settings.allowBackOrder, stockResolver: stockResolver }));
};

var UpdateLineItemContainer = function (_a) {
    var lineItem = _a.lineItem, availableQuantity = _a.availableQuantity;
    var _b = useCartSettings(), minimumQuantity = _b.minimumQuantity, maximumQuantity = _b.maximumQuantity;
    var _c = __read(useUpdateLineItemQuantity(lineItem), 1), updateItemQuantity = _c[0];
    var handleDecreaseQuantity = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        updateItemQuantity(lineItem.quantity - 1, 'decrease');
    }, [lineItem.quantity]);
    var handleIncreaseQuantity = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        updateItemQuantity(lineItem.quantity + 1, 'increase');
    }, [lineItem.quantity]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* QuantitySelector */ "Z"], { onDecreaseQuantity: handleDecreaseQuantity, onIncreaseQuantity: handleIncreaseQuantity, minimumQuantity: minimumQuantity, maximumQuantity: getCalculatedMaximumQuantity(maximumQuantity, availableQuantity), quantity: lineItem.quantity, "data-t": "quantity-selector" }));
};

var ContactLenses = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var availability = lineItem.availability, productUrl = lineItem.productUrl, discount = lineItem.discount, imageUrl = lineItem.imageUrl, brand = lineItem.brand, eyeSide = lineItem.eyeSide, name = lineItem.name, isGift = lineItem.isGift, id = lineItem.id, quantity = lineItem.quantity, price = lineItem.price, colorLens = lineItem.colorLens, packageQuantity = lineItem.packageQuantity, replacementFrequency = lineItem.replacementFrequency, specs = lineItem.specs;
    var iconLabel = eyeSide === 'left' ? labels.iconLeftEye : labels.iconRightEye;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "line-item line-item--contact-lenses" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__media" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { type: "icon", iconName: eyeSide + "-eye", iconLabel: iconLabel, href: productUrl, imageUrl: imageUrl }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { type: "image", className: "line-item__image", href: productUrl, imageUrl: imageUrl, imageAlt: brand.name + " " + brand.model })),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { className: "line-item__content" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { variant: "subheading1", component: "h2", className: "line-item__title" }, name),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity-and-price" },
                !readOnly && !isGift && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity-selector" },
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__delete-btn" },
                            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveLineItemContainer, { lineItem: lineItem })),
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpdateLineItemContainer, { lineItem: lineItem, availableQuantity: _grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__[/* Helpers */ "c"].getAvailableQuantity(availability) })))),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs-and-stock" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ContactLensSpecsContainer, { colorLens: colorLens, packageQuantity: packageQuantity, replacementFrequency: replacementFrequency, specs: specs })),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(StockAndDeliveryContainer, { lineItem: lineItem }),
                readOnly && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__count" },
                    labels.quantity,
                    ": ",
                    quantity))),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(DiscountContainer, { discount: discount }))));
};

var ContactLensesSubscription = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var discount = lineItem.discount, imageUrl = lineItem.imageUrl, isGift = lineItem.isGift, price = lineItem.price, name = lineItem.name, lensType = lineItem.lensType, solutionImageUrl = lineItem.solutionImageUrl, solutionName = lineItem.solutionName, leftEyeProduct = lineItem.leftEyeProduct, rightEyeProduct = lineItem.rightEyeProduct, productUrl = lineItem.productUrl;
    var iconLeftEye = labels.iconLeftEye, iconRightEye = labels.iconRightEye, monthlySubscription = labels.monthlySubscription;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item--contact-lenses-subscription" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "line-item line-item--contact-lenses-subscription-item" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { className: "line-item__media", type: "image", href: productUrl, imageUrl: imageUrl, imageAlt: name }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { className: "line-item__content" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__description" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { variant: "subheading1", component: "h2", className: "line-item__title" }, name),
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span", variant: "body" }, lensType),
                    readOnly && Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { variant: "body-head" }, monthlySubscription)),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity-and-price" },
                    !readOnly && !isGift && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity" },
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity-selector" },
                            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__delete-btn" },
                                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveLineItemContainer, { lineItem: lineItem })),
                            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { variant: "body-head" }, monthlySubscription)))),
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs-and-stock" }),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(DiscountContainer, { discount: discount }))),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "line-item line-item--contact-lenses-subscription-item" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { className: "line-item__media", type: "icon", iconName: "left-eye", iconLabel: iconLeftEye }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { className: "line-item__content" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs-and-stock" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs" },
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span", variant: "body-head" }, leftEyeProduct.name),
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ContactLensSpecsContainer, { specs: leftEyeProduct.specs }))))),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "line-item line-item--contact-lenses-subscription-item" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { className: "line-item__media", type: "icon", iconName: "right-eye", iconLabel: iconRightEye }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { className: "line-item__content" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs-and-stock" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs" },
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span", variant: "body-head" }, rightEyeProduct.name),
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ContactLensSpecsContainer, { specs: rightEyeProduct.specs }))))),
        solutionName && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "line-item line-item--contact-lenses-subscription-item" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { className: "line-item__media", type: "image", imageUrl: solutionImageUrl, imageAlt: solutionName }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { className: "line-item__content" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { variant: "body-head" }, solutionName))))));
};

var classPrefix = 'prescription-glasses-line-item';
var PrescriptionGlasses = function (_a) {
    var settings = _a.settings, lineItem = _a.lineItem, rest = __rest(_a, ["settings", "lineItem"]);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var isPhone = _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].useIsPhone();
    var addOn = lineItem.addOn, currency = lineItem.currency, frame = lineItem.frame, lensType = lineItem.lensType, lensPackage = lineItem.lensPackage, name = lineItem.name, lineItemPrice = lineItem.price, prescription = lineItem.prescription, cartDiscount = lineItem.cartDiscount, productUrl = lineItem.productUrl, imageUrl = lineItem.imageUrl;
    var totalPrice = lineItemPrice.total;
    var totalDiscount = lineItemPrice.total.discount;
    var readOnly = settings.readOnly;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        priceIsZero: getLabel('cart.lineItem.glasses.isIncluded', {
            hideLabelKey: true,
        }),
        lensTypeTitle: getLabel("cart.lineItem.glasses.bundleItem.LensTypes"),
        lensPackageTitle: getLabel("cart.lineItem.glasses.bundleItem.PrescriptionGlassPackages"),
        addOnTitle: getLabel("cart.lineItem.glasses.bundleItem.PrescriptionGlassPackageOptions"),
        totalDiscount: getLabel('cart.item.discount'),
    }); }, [getLabel]);
    var getBundleChildItemProps = function (bundledProduct) {
        var _a, _b, _c, _d, _e;
        return ({
            currency: currency,
            originalPrice: (_b = (_a = bundledProduct.price) === null || _a === void 0 ? void 0 : _a.original) !== null && _b !== void 0 ? _b : 0,
            discountedPrice: ((_c = bundledProduct.price) === null || _c === void 0 ? void 0 : _c.discount) ? (_d = bundledProduct.price) === null || _d === void 0 ? void 0 : _d.gross : undefined,
            priceIsZeroLabel: labels.priceIsZero,
            discountText: (_e = bundledProduct.discount) === null || _e === void 0 ? void 0 : _e.description,
            value: bundledProduct.title,
        });
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix, "data-t": rest['data-t'] },
        !isPhone && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PrescriptionGlassesLineItemImage, { imageUrl: imageUrl, href: productUrl, imageAlt: name, className: classPrefix + "__image" })),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__content" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__row" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__row-item " + classPrefix + "__title-wrapper" },
                    isPhone && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PrescriptionGlassesLineItemImage, { imageUrl: imageUrl, href: productUrl, imageAlt: name, className: classPrefix + "__image" })),
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { className: classPrefix + "__title", variant: isPhone ? 'subheading1' : 'smallest', component: "h3" }, name)),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__frame-price-wrapper" }, frame.price && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PricesContainer, { discount: frame.price.discount, originalPrice: frame.price.original, totalPrice: frame.price.gross, orientation: isPhone ? 'vertical' : 'horizontal' })))),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemGlassesPrescription */ "H"], { className: classPrefix + "__prescription", prescription: prescription }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* PrescriptionGlassesBundleChildItem */ "V"], __assign({}, getBundleChildItemProps(lensType), { label: labels.lensTypeTitle })),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* PrescriptionGlassesBundleChildItem */ "V"], __assign({}, getBundleChildItemProps(lensPackage), { label: labels.lensPackageTitle })),
            addOn && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* PrescriptionGlassesBundleChildItem */ "V"], __assign({}, getBundleChildItemProps(addOn), { label: labels.addOnTitle }))),
            cartDiscount && cartDiscount.amount > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__row" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__row-item " + classPrefix + "__cart-discount" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: classPrefix + "__cart-discount-text" }, cartDiscount.description)),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: cartDiscount.amount, currency: currency, className: classPrefix + "__cart-discount-value" }))),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__row" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__row-item " + classPrefix + "__total-price-wrapper" },
                    !readOnly && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null,
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__delete-btn" },
                            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveLineItemContainer, { lineItem: lineItem })),
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpdateLineItemContainer, { lineItem: lineItem }))),
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PricesContainer, { discount: 0, originalPrice: totalPrice.gross, totalPrice: 0 }))),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix + "__row" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: classPrefix + "__total-discount" }, totalDiscount > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Discount, { absoluteValue: totalDiscount, currency: currency, labels: { discount: labels.totalDiscount } })))))));
};

var Solutions = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var availability = lineItem.availability, discount = lineItem.discount, id = lineItem.id, imageUrl = lineItem.imageUrl, isGift = lineItem.isGift, price = lineItem.price, quantity = lineItem.quantity, name = lineItem.name, solutionType = lineItem.solutionType, solutionVolume = lineItem.solutionVolume;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "line-item line-item--solutions" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { className: "line-item__media", type: "image", imageUrl: imageUrl, imageAlt: name }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { className: "line-item__content" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__description" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { variant: "subheading1", component: "h2", className: "line-item__title" }, name)),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity-and-price" },
                !readOnly && !isGift && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__quantity-selector" },
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__delete-btn" },
                            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveLineItemContainer, { lineItem: lineItem })),
                        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpdateLineItemContainer, { lineItem: lineItem, availableQuantity: _grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__[/* Helpers */ "c"].getAvailableQuantity(availability) })))),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs-and-stock" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "line-item__specs" },
                    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(SolutionSpecsContainer, { type: solutionType, volume: solutionVolume })),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(StockAndDeliveryContainer, { lineItem: lineItem }),
                readOnly && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "line-item__count" },
                    labels.quantity,
                    ": ",
                    quantity))),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(DiscountContainer, { discount: discount }))));
};

var Sunglasses = function (_a) {
    var lineItem = _a.lineItem, settings = _a.settings, labels = _a.labels;
    var readOnly = settings.readOnly;
    var availability = lineItem.availability, brand = lineItem.brand, discount = lineItem.discount, id = lineItem.id, imageUrl = lineItem.imageUrl, isGift = lineItem.isGift, price = lineItem.price, productUrl = lineItem.productUrl, quantity = lineItem.quantity, name = lineItem.name;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "line-item line-item--sunglasses" },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { className: "line-item__media", type: "image", href: productUrl, imageUrl: imageUrl, imageAlt: brand.name + " " + brand.model }),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { className: "line-item__content" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "line-item__description" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { variant: "subheading1", component: "h2", className: "line-item__title" }, name),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span", variant: "body" },
                    brand.model,
                    brand.modelCode && brand.modelCode !== brand.model ? " " + brand.modelCode : null)),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "line-item__quantity-and-price" },
                !readOnly && !isGift && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "line-item__quantity" },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "line-item__quantity-selector" },
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "line-item__delete-btn" },
                            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(RemoveLineItemContainer, { lineItem: lineItem })),
                        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(UpdateLineItemContainer, { lineItem: lineItem, availableQuantity: _grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__[/* Helpers */ "c"].getAvailableQuantity(availability) })))),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(PricesContainer, { discount: price.total.discount, originalPrice: price.total.original, totalPrice: price.total.gross })),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "line-item__specs-and-stock" },
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "line-item__specs" }),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(StockAndDeliveryContainer, { lineItem: lineItem }),
                readOnly && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: "line-item__count" },
                    labels.quantity,
                    ": ",
                    quantity))),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(DiscountContainer, { discount: discount }))));
};

var LineItemsContainer = function (_a) {
    var lineItems = _a.lineItems;
    var settings = useCartSettings();
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        quantity: getLabel('cart.item.quantity'),
        iconLeftEye: getLabel('products.contactLenses.leftEye'),
        iconRightEye: getLabel('products.contactLenses.rightEye'),
        monthlySubscription: getLabel('products.monthlySubscription'),
    }); }, [getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, lineItems.map(function (lineItem) {
        switch (lineItem.type) {
            case 'sunglasses':
                return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Sunglasses, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            case 'prescription-glasses':
                return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(PrescriptionGlasses, { key: lineItem.id, lineItem: lineItem, settings: settings });
            case 'solutions':
                return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Solutions, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            case 'contact-lenses':
                return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ContactLenses, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            case 'contact-lenses-subscription':
                return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ContactLensesSubscription, { key: lineItem.id, lineItem: lineItem, settings: settings, labels: labels }));
            default:
                return null;
        }
    })));
};

var LineItems = function (props) { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(LineItemsContainer, __assign({}, props)); };

var Cart = function (_a) {
    var lineItems = _a.lineItems, readOnly = _a.readOnly, labels = _a.labels, deliveryResolver = _a.deliveryResolver, goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage;
    var availability = lineItems.map(function (item) { return item.availability; });
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('cart', { 'cart--read-only': readOnly }), "data-t": "cart" },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h1", { className: "cart__header" }, labels.cartTitle),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: "cart__content" },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_inventory__WEBPACK_IMPORTED_MODULE_8__[/* DeliveryIndicator */ "a"], { availability: availability, deliveryResolver: deliveryResolver }),
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(LineItems, { lineItems: lineItems })),
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Footer, { goToCheckout: goToCheckout, goToPreviousPage: goToPreviousPage, readOnly: readOnly })));
};

var CartContainer = function (_a) {
    var onEmptyCartButtonClick = _a.onEmptyCartButtonClick, goToCheckout = _a.goToCheckout, goToPreviousPage = _a.goToPreviousPage;
    var _b = useCart(), cart = _b.cart, called = _b.called, loading = _b.loading, error = _b.error;
    var settings = useCartSettings();
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])();
    var cartExists = cart !== null;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        cartTitle: intl.getLabel('cart.title'),
    }); }, [intl]);
    if (cartExists && (loading || !called)) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "cart", "data-t": "loading-cart" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Loader */ "L"], null)));
    }
    var lineItems = (cart === null || cart === void 0 ? void 0 : cart.lineItems) || [];
    if (!cartExists || !cart || (!loading && (error || lineItems.length < 1))) {
        return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(EmptyCart$1, { onClick: onEmptyCartButtonClick });
    }
    var deliveryResolver = settings.deliveryResolverFactory && settings.deliveryResolverFactory(lineItems);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Cart, { lineItems: lineItems, labels: labels, readOnly: settings.readOnly, deliveryResolver: deliveryResolver, goToCheckout: goToCheckout, goToPreviousPage: goToPreviousPage }));
};

var Cart$1 = function (_a) {
    var settings = _a.settings, containerProps = __rest(_a, ["settings"]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartSettingsProvider, { settings: settings },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartProvider, null,
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartContainer, __assign({}, containerProps)))));
};

var CartCounter = function (_a) {
    var count = _a.count;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, count > 0 && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "cart-counter", "data-t": "cart-counter" }, count))));
};

var CartButtonContainer = function () {
    var _a = __read(useCartStorage(), 2), cart = _a[0], _b = _a[1], setCartCount = _b.setCartCount, reset = _b.reset;
    var onValidationError = function (validationCodes) {
        validationCodes.forEach(function (code) { return _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].failed("cart." + code); });
    };
    var _c = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useLazyQuery */ "e"])(GET_TOTAL_LINE_ITEMS, {
        onCompleted: function (data) {
            if (!data.getCart.validationErrors) {
                setCartCount(data.getCart.cart.numberOfItems);
            }
            else {
                var validationErrorCodes = getValidationErrorCodes(data.getCart.validationErrors);
                onValidationError && onValidationError(validationErrorCodes);
                reset();
            }
        },
        onError: function () {
            reset();
        },
    }), 1), getTotalLineItems = _c[0];
    var count = Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useReactiveVar */ "g"])(cartCountVar);
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
        if (cart.cartId) {
            getTotalLineItems({
                variables: { id: cart.cartId },
            });
        }
    }, []);
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(CartCounter, { count: count });
};

var CartButton = function (_a) {
    var href = _a.href, className = _a.className, label = _a.label;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("a", { className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('cart-button', className), href: href, title: label },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "b"], { name: "shopping-bag" }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartButtonContainer, null)));
};

var classPrefix$1 = 'mini-cart-v2';
var ActionButtons = function (_a) {
    var buttonsRef = _a.buttonsRef, labels = _a.labels, links = _a.links, showStickyButtons = _a.showStickyButtons;
    var Buttons = (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null,
        links.cart ? (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], { "aria-label": labels.toCart, caption: labels.toCart, className: classPrefix$1 + "__action-button", href: links.cart, size: "small" })) : null,
        links.checkout ? (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], { "aria-label": labels.toCheckout, caption: labels.toCheckout, className: classPrefix$1 + "__action-button", href: links.checkout, size: "small", variant: "outline" })) : null));
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null,
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$1 + "__action-buttons", ref: buttonsRef }, Buttons),
        showStickyButtons ? Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* StickyCallToAction */ "jb"], { button: Buttons }) : null));
};

var CartTotals = function () { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Totals$1, { className: "mini-cart-v2__totals", showSubTotal: true, showTotalDiscount: false })); };

var Product = function (_a) {
    var body = _a.body, imageUrl = _a.imageUrl, price = _a.price, title = _a.title;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItem */ "D"], { className: "mini-cart-v2__product" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemMedia */ "I"], { className: "mini-cart-v2__product--image", type: "image", imageUrl: imageUrl, imageAlt: title }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemContent */ "F"], { title: title, body: body }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* LineItemAside */ "E"], { currency: price.currency, price: price.originalPrice, discountPrice: price.discountedPrice })));
};

var Title = function (_a) {
    var isSmallScreen = _a.isSmallScreen, value = _a.value;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { className: "mini-cart-v2__title", variant: isSmallScreen ? 'subheading1' : 'smallest' }, value));
};

var ActionButtonsContainer = function (_a) {
    var links = _a.links;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        toCart: getLabel('cart.actions.goToCart'),
        toCheckout: getLabel('cart.actions.goToCheckout'),
    }); }, [getLabel]);
    var _b = __read(Object(react_intersection_observer__WEBPACK_IMPORTED_MODULE_11__[/* useInView */ "a"])(), 2), buttonsRef = _b[0], buttonsInview = _b[1];
    var showStickyButtons = isSmallScreen && !buttonsInview;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ActionButtons, { buttonsRef: buttonsRef, isSmallScreen: isSmallScreen, labels: labels, links: links, showStickyButtons: showStickyButtons }));
};

var getLineItemBody = function (lineItem, labels) {
    if (lineItem.type === 'contact-lenses') {
        var eyeSideLabel = lineItem.eyeSide === 'left' ? labels.leftEye : labels.rightEye;
        return labels.quantity + ": " + lineItem.quantity + " | " + eyeSideLabel;
    }
    if (lineItem.type === 'contact-lenses-subscription') {
        return labels.monthlySubscription;
    }
    if (lineItem.type === 'sunglasses') {
        var _a = lineItem.brand, model = _a.model, modelCode = _a.modelCode;
        return "" + model + (modelCode && modelCode !== model ? " " + modelCode : '');
    }
    if (lineItem.type === 'solutions') {
        return lineItem.solutionType + ", " + lineItem.solutionVolume + labels.unitMilli;
    }
    // TODO: Add body text for prescription glasses
    return '';
};

var LineItemsContainer$1 = function (_a) {
    var lineItems = _a.lineItems;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        monthlySubscription: getLabel('products.monthlySubscription'),
        quantity: getLabel('cart.item.quantity'),
        unitMilli: getLabel('products.unit.metric.liter.milli.abbr'),
        leftEye: getLabel('products.contactLenses.leftEye'),
        rightEye: getLabel('products.contactLenses.rightEye'),
    }); }, [getLabel]);
    var products = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
        return lineItems.map(function (lineItem) { return ({
            sku: lineItem.type === 'prescription-glasses' ? lineItem.frame.sku : lineItem.sku,
            imageUrl: lineItem.imageUrl,
            price: {
                discountedPrice: lineItem.price.total.discount ? lineItem.price.total.gross : undefined,
                originalPrice: lineItem.price.total.original,
                currency: lineItem.currency,
            },
            title: lineItem.name,
            body: (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { component: "span", variant: "body" }, getLineItemBody(lineItem, labels))),
        }); });
    }, [lineItems, labels]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, products.map(function (product) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Product, __assign({ key: product.sku }, product))); })));
};

var SuccessNotificationContainer = function () {
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])();
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        successNotification: intl.getLabel('cart.success.notification'),
    }); }, [intl]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Alert */ "c"], { icon: "checkmark", type: "success", message: labels.successNotification });
};

var TitleContainer = function () {
    var getFormattedLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getFormattedLabel;
    var data = useGetCart().data;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var value = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () {
        var _a;
        return getFormattedLabel('cart.minicart.totalsTitle', {
            labelData: { numberOfItems: "" + ((_a = data === null || data === void 0 ? void 0 : data.getCart.cart.numberOfItems) !== null && _a !== void 0 ? _a : 0) },
        });
    }, [getFormattedLabel, data]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Title, { value: value, isSmallScreen: isSmallScreen });
};

var classPrefix$2 = 'mini-cart-v2';
var MiniCart = function (_a) {
    var _b = _a.alerts, alerts = _b === void 0 ? [] : _b, children = _a.children, _c = _a.components, components = _c === void 0 ? {} : _c, links = _a.links, lineItems = _a.lineItems;
    var isSmallScreen = _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].useIsBelow(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* MediaQuery */ "P"].BreakpointName.TABLET_LANDSCAPE);
    var Components = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        ActionButtons: components.ActionButtons || ActionButtonsContainer,
        CartTotals: components.CartTotals || CartTotals,
        LineItems: components.LineItems || LineItemsContainer$1,
        SuccessNotification: components.SuccessNotification || SuccessNotificationContainer,
        Title: components.Title || TitleContainer,
    }); }, [components]);
    var HorizontalDivider = (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Divider */ "e"], { className: classPrefix$2 + "__divider", orientation: "horizontal", theme: "light" }));
    if (isSmallScreen) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartProvider, null,
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.Title, null),
            HorizontalDivider,
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.SuccessNotification, null),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.LineItems, { lineItems: lineItems }),
            HorizontalDivider,
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.CartTotals, null),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.ActionButtons, { links: links }),
            alerts.length ? Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$2 + "__alerts" }, alerts) : null,
            children && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isFunction */ "x"])(children) ? children(lineItems) : children));
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(CartProvider, null,
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$2 + "__box" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$2 + "__added-item" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.SuccessNotification, null),
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.LineItems, { lineItems: lineItems }))),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Divider */ "e"], { className: classPrefix$2 + "__divider--vertical", orientation: "vertical", isFlexItem: true, theme: "light" }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$2 + "__box" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$2 + "__basket" },
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.Title, null),
                HorizontalDivider,
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.CartTotals, null),
                HorizontalDivider,
                Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Components.ActionButtons, { links: links }))),
        alerts.length ? Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$2 + "__alerts" }, alerts) : null,
        children && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isFunction */ "x"])(children) ? children(lineItems) : children));
};

var ModalContainer = function (_a) {
    var _b, _c;
    var modal = _a.modal, rest = __rest(_a, ["modal"]);
    var _d = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(undefined), 2), lineItems = _d[0], setLineItems = _d[1];
    useMiniCartListener(function (event) {
        if (!lineItems || event.detail.type === 'updated') {
            setLineItems(event.detail.lineItems);
        }
    });
    var handleClose = function () {
        setLineItems(undefined);
        (modal === null || modal === void 0 ? void 0 : modal.onModalClose) && modal.onModalClose();
    };
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Modal */ "Q"], __assign({}, modal, { className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('mini-cart-v2', modal === null || modal === void 0 ? void 0 : modal.className), isOpen: (_b = (!!lineItems || (modal === null || modal === void 0 ? void 0 : modal.isOpen))) !== null && _b !== void 0 ? _b : false, onModalClose: handleClose, showIcon: (_c = modal === null || modal === void 0 ? void 0 : modal.showIcon) !== null && _c !== void 0 ? _c : true }), lineItems ? Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(MiniCart, __assign({ lineItems: lineItems }, rest)) : null));
};

var MiniCartModal = function (props) {
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ModalContainer, __assign({}, props));
};

var useReplaceLineItemContactLensesBundleBenelux = function () {
    var _a;
    var intl = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])();
    var settings = useCartSettings();
    var _b = __read(useCartStorage(), 1), cart = _b[0];
    var _c = __read(Object(_grandvision_graphql__WEBPACK_IMPORTED_MODULE_3__[/* useMutation */ "f"])(REPLACE_CONTACT_LENS_BUNDLE_BENELUX_CART_LINE_ITEM), 2), replaceCartLineItem = _c[0], replaceCartLineItemMutation = _c[1];
    var handleOnCompleted = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (replacedLineItem, data, onSuccess, onValidationError, onError) {
        var result = data.replaceContactLensBundleBeneluxCartLineItem;
        if (!result.success) {
            var validationErrors = getValidationErrorCodes(result.validationErrors);
            onValidationError && onValidationError(validationErrors);
            return;
        }
        if (!result.cart) {
            if (onError) {
                onError(errorsMapping.CART_IS_EMPTY);
            }
            return;
        }
        var lineItemsInCart = result.cart.lineItems;
        var addedLineItems = lineItemsInCart.filter(function (_a) {
            var sku = _a.sku;
            return sku === replacedLineItem.newSku;
        });
        var addedLineItemsMappedToViewModel = lineItemDataMapper(addedLineItems, settings, intl);
        var SdProductObjects = addedLineItemsMappedToViewModel.map(createProductObject);
        dispatchMiniCartEvent('updated', addedLineItemsMappedToViewModel);
        _grandvision_analytics__WEBPACK_IMPORTED_MODULE_5__[/* CartV2Actions */ "f"].addToCartSdAction(SdProductObjects);
        onSuccess && onSuccess(addedLineItemsMappedToViewModel);
    }, [intl, settings]);
    var replaceLineItem = react__WEBPACK_IMPORTED_MODULE_0___default.a.useCallback(function (lineItemDrafts, onSuccess, onValidationError, onError) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, data_1, errors, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!cart.cartId) {
                        if (onError) {
                            onError(errorsMapping.MISSING_CART_ID);
                        }
                        return [2 /*return*/];
                    }
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, replaceCartLineItem({
                            variables: {
                                cartInput: {
                                    cartId: cart.cartId,
                                    lineItemToReplace: lineItemDrafts,
                                },
                            },
                        })];
                case 2:
                    _a = _b.sent(), data_1 = _a.data, errors = _a.errors;
                    if (errors) {
                        if (onError) {
                            onError(errorsMapping.SOMETHING_WENT_WRONG);
                        }
                    }
                    if (data_1) {
                        handleOnCompleted(lineItemDrafts, data_1, onSuccess, onValidationError, onError);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    if (onError) {
                        onError(errorsMapping.SOMETHING_WENT_WRONG);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [cart.cartId, handleOnCompleted, replaceCartLineItem]);
    var called = replaceCartLineItemMutation.called, loading = replaceCartLineItemMutation.loading, error = replaceCartLineItemMutation.error, data = replaceCartLineItemMutation.data;
    var newCart = (_a = data === null || data === void 0 ? void 0 : data.replaceContactLensBundleBeneluxCartLineItem.cart) !== null && _a !== void 0 ? _a : null;
    return [replaceLineItem, { called: called, loading: loading, error: error, cart: newCart }];
};

var baseClassName = 'clbb-solution-picker';

var Loader = function () { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Loader */ "L"], { className: baseClassName + "__loader" }); };

var Description = function (_a) {
    var value = _a.value;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("p", { className: baseClassName + "__description" }, value));
};

var DescriptionContainer = function (_a) {
    var description = _a.description;
    var locale = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().locale;
    var value = description && Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getLocalizedValue */ "q"])(description, locale);
    if (!value) {
        return null;
    }
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Description, { value: value });
};

var className = baseClassName + "-item";
var Solution = function (_a) {
    var _b;
    var isChecked = _a.isChecked, isLoading = _a.isLoading, onChange = _a.onChange, solution = _a.solution, title = _a.title;
    var bundleSku = solution.bundleSku, bundlePrice = solution.bundlePrice, description = solution.description, imageUrl = solution.imageUrl;
    return (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: className + "__wrapper" },
        react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* RadioButton */ "ab"], { isChecked: isChecked, onChange: onChange, position: "bottom", value: bundleSku, disabled: isLoading, className: classnames__WEBPACK_IMPORTED_MODULE_7___default()(className, (_b = {},
                _b[className + "--empty"] = !description && !imageUrl,
                _b)) },
            react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: className + "__container" },
                imageUrl && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: className + "__image-holder" },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("img", { className: className + "__image", src: imageUrl, alt: title }))),
                react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("h3", { className: className + "__title" }, title),
                bundlePrice[0].value && (react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", { className: className + "__price" },
                    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Price */ "W"], { value: bundlePrice[0].value.centAmount, currency: bundlePrice[0].value.currencyCode })))))));
};

var SolutionContainer = function (props) {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])(), getLabel = _a.getLabel, locale = _a.locale;
    var title = props.solution.name
        ? Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getLocalizedValue */ "q"])(props.solution.name, locale)
        : getLabel('products.contactLenses.solutions.missing');
    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Solution, __assign({}, props, { title: title }));
};

var SolutionPicker = function (_a) {
    var activeSolution = _a.activeSolution, handleClick = _a.handleClick, isLoading = _a.isLoading, solutions = _a.solutions;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: baseClassName },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: baseClassName + "__list" }, solutions.map(function (solution) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(SolutionContainer, { isChecked: activeSolution ? solution.bundleSku === activeSolution.bundleSku : false, isLoading: isLoading, key: solution.bundleSku, onChange: handleClick, solution: solution })); })),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(DescriptionContainer, { description: activeSolution === null || activeSolution === void 0 ? void 0 : activeSolution.description })));
};

var useFetchBundleSolutions = function (sku) {
    var _a = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useApiConfig */ "N"])(), apiKey = _a.apiKey, productsUrl = _a.productsUrl;
    var params = react__WEBPACK_IMPORTED_MODULE_0___default.a.useMemo(function () { return ({ sku: sku }); }, [sku]);
    var _b = __read(Object(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_12__[/* useApiClient */ "k"])(_grandvision_api_client__WEBPACK_IMPORTED_MODULE_12__[/* Products */ "h"].getContactLensBundles, {}, productsUrl, params, apiKey), 2), loading = _b[0], data = _b[1];
    return [loading, data === null || data === void 0 ? void 0 : data.solutions];
};

var ContactLensesBundleBeneluxSolutionsContainer = function (_a) {
    var subscriptionProductSku = _a.subscriptionProductSku;
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(subscriptionProductSku), 2), bundleSku = _b[0], setBundleSku = _b[1];
    var _c = __read(useFetchBundleSolutions(subscriptionProductSku), 2), isFetching = _c[0], solutions = _c[1];
    var activeSolution = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return solutions === null || solutions === void 0 ? void 0 : solutions.find(function (solution) { return solution.bundleSku === bundleSku; }); }, [bundleSku, solutions]);
    var _d = __read(useReplaceLineItemContactLensesBundleBenelux(), 2), replaceLineItem = _d[0], loading = _d[1].loading;
    var handleClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (ev) {
        var newSku = ev.currentTarget.value;
        var existingSku = bundleSku;
        var draft = {
            newSku: newSku,
            existingSku: existingSku,
        };
        var onSuccess = function () {
            setBundleSku(newSku);
            _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].info('cart.notification.updatedCart');
        };
        var handleError = function (message) {
            var errorMessages = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* isArray */ "v"])(message) ? message : [message];
            errorMessages.forEach(function (errorMessage) { return _grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* toast */ "vb"].failed("cart." + errorMessage); });
        };
        replaceLineItem(draft, onSuccess, handleError, handleError);
    }, [bundleSku, replaceLineItem]);
    if (isFetching) {
        return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Loader, null);
    }
    if (!solutions) {
        return null;
    }
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(SolutionPicker, { activeSolution: activeSolution, handleClick: handleClick, isLoading: loading, solutions: solutions }));
};

var ContactLensesBundleBeneluxSolutions = function (props) {
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ContactLensesBundleBeneluxSolutionsContainer, __assign({}, props));
};

var AddButton = function (props) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], __assign({ size: "custom", "data-t": "add-button", className: "add-button", variant: "ghost", color: "primary" }, props))); };

var AddButtonSuccessMessage = function (_a) {
    var caption = _a.caption;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "add-button-success-message" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("span", { className: "add-button-success-message__text" }, caption)));
};

var classPrefix$3 = 'upsell-item-product';
var Product$1 = function (_a) {
    var body = _a.body, price = _a.price, title = _a.title, imageUrl = _a.imageUrl;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "" + classPrefix$3 },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classPrefix$3 + "__image-container" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("img", { className: classPrefix$3 + "__image", src: imageUrl + "?w=300&auto=format", alt: title })),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { className: classPrefix$3 + "__title", variant: "body-head" }, title),
        body && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Text */ "k"], { className: classPrefix$3 + "__subtitle", variant: "caption" }, body)),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* PriceTag */ "X"], { className: classPrefix$3 + "__price", originalPrice: price.originalPrice, discountedPrice: price.discountedPrice, currency: price.currency })));
};

var RemoveButton = function (props) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Button */ "f"], __assign({ size: "custom", "data-t": "remove-button", className: "remove-button", variant: "ghost" }, props))); };

var UpsellLayout = function (props) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "upsell-layout" },
    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Divider */ "e"], { className: "upsell-layout__divider", orientation: "horizontal", theme: "light" }),
    Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_6__[/* Heading */ "f"], { className: "upsell-layout__header", variant: "smallest", component: "h2" }, props.heading),
    props.children)); };

var RemoveButtonContainer = function (_a) {
    var lineItem = _a.lineItem, onSuccess = _a.onSuccess;
    var _b = __read(useRemoveFromCart(lineItem, onSuccess), 2), removeFromCart = _b[0], loading = _b[1].loading;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        removeFromCart: getLabel('cart.actions.removeFromCart'),
    }); }, [getLabel]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveButton, { isLoading: loading, caption: labels.removeFromCart, onClick: removeFromCart }));
};

var AddButtonContainer = function (_a) {
    var lineItemDrafts = _a.lineItemDrafts, onSuccess = _a.onSuccess;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var _b = __read(useAddToCart(), 2), addToCart = _b[0], loading = _b[1].loading;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        addToCart: getLabel('cart.actions.addToCart'),
    }); }, [getLabel]);
    var handOnClick = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () { return addToCart(lineItemDrafts, onSuccess); }, [
        lineItemDrafts,
        onSuccess,
    ]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(AddButton, { isLoading: loading, caption: labels.addToCart, onClick: handOnClick });
};

var AddButtonSuccessMessageContainer = function () {
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        addedToCart: getLabel('cart.notification.addedToCart'),
    }); }, [getLabel]);
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(AddButtonSuccessMessage, { caption: labels.addedToCart });
};

var UpsellItemContainer = function (item) {
    var _a = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(null), 2), addedLineItem = _a[0], setAddedItem = _a[1];
    var _b = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])(false), 2), successMessage = _b[0], setSuccessMessage = _b[1];
    var itemDraft = {
        sku: item.sku,
        quantity: 1,
        type: 'regular',
    };
    var onAddedSuccess = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function (_a) {
        var _b = __read(_a, 1), lineItem = _b[0];
        setSuccessMessage(true);
        setTimeout(function () {
            setSuccessMessage(false);
        }, 2000);
        setAddedItem(lineItem);
    }, [setSuccessMessage, setAddedItem]);
    var onRemovedSuccess = Object(react__WEBPACK_IMPORTED_MODULE_0__["useCallback"])(function () {
        setAddedItem(null);
    }, [setAddedItem]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: classnames__WEBPACK_IMPORTED_MODULE_7___default()('upsell-item', { 'upsell-item--is-added': addedLineItem }) },
        addedLineItem && Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_icons__WEBPACK_IMPORTED_MODULE_9__[/* Icon */ "b"], { name: "checkmark-circle", className: "upsell-item__checkmark" }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(Product$1, { body: item.body, price: item.price, title: item.title, imageUrl: item.imageUrl }),
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "upsell-item__action-button" },
            !addedLineItem && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(AddButtonContainer, { lineItemDrafts: [itemDraft], onSuccess: onAddedSuccess })),
            addedLineItem && !successMessage && (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(RemoveButtonContainer, { lineItem: addedLineItem, onSuccess: onRemovedSuccess })),
            successMessage && Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(AddButtonSuccessMessageContainer, null))));
};

var getPrice = function (prices) {
    if (!Array.isArray(prices) || !prices.length) {
        return undefined;
    }
    var price = prices[0];
    if (!price.discounted) {
        return {
            originalPrice: price.value.centAmount,
            currency: _grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* Currencies */ "d"][price.value.currencyCode],
        };
    }
    var discounted = price.discounted;
    return {
        currency: _grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* Currencies */ "d"][price.value.currencyCode],
        originalPrice: price.value.centAmount,
        discountedPrice: discounted.value.centAmount,
    };
};

/**
 * From the API returned upsell data, create objects that can be processed
 * by the Upsell components
 */
var parseCTUpsellData = function (upsellProducts, language, staticsUrl, getLabel) {
    if (!upsellProducts || upsellProducts.length === 0) {
        return [];
    }
    return upsellProducts.reduce(function (storedUpsellProducts, solution, index) {
        var _a;
        var masterVariant = solution.masterVariant, name = solution.name;
        var price = getPrice(masterVariant.prices);
        if (price === undefined || index > 3) {
            return storedUpsellProducts;
        }
        var title = name[language];
        var sku = (_a = masterVariant.sku) !== null && _a !== void 0 ? _a : '';
        var imageUrl = getLineItemImageUrl(masterVariant, staticsUrl);
        var solutionType = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getAttrValue */ "m"])(masterVariant, 'solutionType');
        var volume = Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_4__[/* getAttrValue */ "m"])(masterVariant, 'volume');
        var availability = masterVariant.availability;
        var channelsMap = (availability === null || availability === void 0 ? void 0 : availability.channels) ? Object.entries(availability.channels) : [];
        var hasAvailableQuantity = channelsMap.some(function (_a) {
            var _b = __read(_a, 2), channel = _b[1];
            return channel.availableQuantity;
        });
        // When no availablity on product variant this item should still be orderable
        var isAvailable = !availability ? true : hasAvailableQuantity;
        if (!isAvailable) {
            return storedUpsellProducts;
        }
        var body;
        if (solutionType && volume) {
            body = solutionType + ", " + volume + getLabel('products.unit.metric.liter.milli.abbr');
        }
        var product = {
            title: title,
            body: body,
            imageUrl: imageUrl,
            sku: sku,
            price: price,
        };
        return __spread(storedUpsellProducts, [product]);
    }, []);
};

var UpsellCategoryContainer = function (_a) {
    var categoryKey = _a.categoryKey;
    var _b = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useApiConfig */ "N"])(), apiKey = _b.apiKey, productsUrl = _b.productsUrl;
    var staticsUrl = useCartSettings().staticsUrl;
    var _c = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])(), getLabel = _c.getLabel, language = _c.language;
    var _d = __read(Object(react__WEBPACK_IMPORTED_MODULE_0__["useState"])([]), 2), upsellProducts = _d[0], setUpsellProducts = _d[1];
    /**
     * Fetch and parse upsell products for a given category key.
     */
    var cancelled = false;
    Object(react__WEBPACK_IMPORTED_MODULE_0__["useEffect"])(function () {
        var fetchUpsellProducts = function () { return __awaiter(void 0, void 0, void 0, function () {
            var results, parsedProducts, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, _grandvision_api_client__WEBPACK_IMPORTED_MODULE_12__[/* Products */ "h"].query(productsUrl, { categoryType: categoryKey }, apiKey)];
                    case 1:
                        results = (_a.sent()).results;
                        if (cancelled) {
                            return [2 /*return*/];
                        }
                        parsedProducts = parseCTUpsellData(results, language, staticsUrl, getLabel);
                        setUpsellProducts(parsedProducts);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        console.error("Error fetching upsell products " + e_1.message);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        fetchUpsellProducts();
        return function () {
            cancelled = true;
        };
    }, [apiKey, productsUrl, categoryKey, setUpsellProducts]);
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, upsellProducts.map(function (product) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellItemContainer, __assign({ key: product.sku }, product))); })));
};

var UpsellCategory = function (_a) {
    var recommendedCategoryKey = _a.recommendedCategoryKey;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "upsell" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "upsell__content" },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellCategoryContainer, { categoryKey: recommendedCategoryKey }))));
};

var UpsellProducts = function (_a) {
    var products = _a.products;
    return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "upsell" },
        Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])("div", { className: "upsell__content" }, products.map(function (product) { return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellItemContainer, __assign({ key: product.sku }, product))); }))));
};

var productTypeSpecificMessageLabelMapping = {
    'contact-lenses': 'cart.notification.upsell.contactLenses.message',
    'contact-lenses-subscription': 'cart.notification.upsell.contactLensesSubscription.message',
    'prescription-glasses': 'cart.notification.upsell.prescriptionGlasses.message',
    solutions: 'cart.notification.upsell.solution.message',
    sunglasses: 'cart.notification.upsell.sunglasses.message',
};
var ProductTypeMessages = function (_a) {
    var lineItemTypes = _a.lineItemTypes;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var messages = lineItemTypes
        .map(function (t) { return getLabel(productTypeSpecificMessageLabelMapping[t], { hideLabelKey: true }); })
        .filter(Boolean);
    if (messages.length <= 0) {
        return null;
    }
    return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(_grandvision_common__WEBPACK_IMPORTED_MODULE_2__[/* Alert */ "c"], { message: __spread(messages) });
};
var UpsellContainer = function (_a) {
    var lineItems = _a.lineItems, products = _a.products, recommendedCategoryKey = _a.recommendedCategoryKey, subscriptionProductSku = _a.subscriptionProductSku;
    var getLabel = Object(_grandvision_state__WEBPACK_IMPORTED_MODULE_1__[/* useIntl */ "Q"])().getLabel;
    var labels = Object(react__WEBPACK_IMPORTED_MODULE_0__["useMemo"])(function () { return ({
        upsellCategoryHeading: getLabel('cart.notification.productAdded'),
        clbbCategoryHeading: getLabel('products.contactLenses.solutions.title'),
    }); }, [getLabel]);
    var lineItemTypes = __spread(new Set(lineItems.map(function (l) { return l.type; })));
    if (subscriptionProductSku &&
        lineItems.some(function (lineItem) { return lineItem.type === 'contact-lenses-subscription'; })) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellLayout, { heading: labels.clbbCategoryHeading },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ProductTypeMessages, { lineItemTypes: lineItemTypes }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ContactLensesBundleBeneluxSolutions, { subscriptionProductSku: subscriptionProductSku })));
    }
    if (recommendedCategoryKey) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellLayout, { heading: labels.upsellCategoryHeading },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ProductTypeMessages, { lineItemTypes: lineItemTypes }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellCategory, { recommendedCategoryKey: recommendedCategoryKey })));
    }
    if (products) {
        return (Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellLayout, { heading: labels.upsellCategoryHeading },
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(ProductTypeMessages, { lineItemTypes: lineItemTypes }),
            Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellProducts, { products: products })));
    }
    return null;
};

var Upsell = function (props) { return Object(react__WEBPACK_IMPORTED_MODULE_0__["createElement"])(UpsellContainer, __assign({}, props)); };


//# sourceMappingURL=index.es.js.map


/***/ })

}]);